import { useEffect, useMemo, useState } from 'react';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku';
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { useNotification } from './NotifPopup';
import { PageKonten9_Pict } from "./Page9_Pict";
import { PageKonten9_Edit } from "./Page9_Edit";
import { PageKonten9_Show } from "./Page9_Show";
import { PageKonten32_Rotasi } from "./Page32_Rotasi";
import { ModalCariMT } from "./Page27_Cari";
import { FormasiBan } from './FormasiBan';
import { PageKonten15OdoTd } from './Page25_UpdateData';
import { PageKonten26Irregular } from './Page26_Irregular';
import { useConfirm } from './ModalConfirm';

const formatYYYYMMDD = (date) => {
  if (!date) return null;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return String(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const ACTIONS = [
  {
    value: "Rotasi/Ganti Ban",
    title: "Rotasi/Ganti dan Repair Ban",
    description: "Aktivitas Rotasi dan Repair Ban OTF.",
    tagline: "Workflow rotasi-ganti",
    submitLabel: "Buka",
    type: "rotasi_ganti_ban"
  },
  {
    value: "Storing",
    title: "Storing",
    description: "Catat aktivitas storing di lapangan.",
    tagline: "Insidental MT",
    submitLabel: "Simpan",
    type: "storing_irregular"
  },
  {
    value: "Tambah MT",
    title: "Penambahan Unit MT",
    description: "Tambahkan unit MT baru.",
    tagline: "Persiapkan penambahan armada",
    submitLabel: "Lanjutkan",
    type: "initial"
  },
  {
    value: "Edit Profil MT",
    title: "Edit Profil MT",
    description: "Koreksi profil MT yang sudah terdaftar.",
    tagline: "Koreksi data unit",
    submitLabel: "Lanjutkan",
    type: "initial_edit"
  },
  {
    value: "Mutasi",
    title: "Mutasi Unit MT",
    description: "Pengalihan unit secara administratif ke cabang atau pool lain.",
    tagline: "Keberlanjutan histori MT",
    submitLabel: "Upload dan Tutup",
    type: "mutasi"
  },
  {
    value: "Ubah Status MT",
    title: "Ubah Status MT",
    description: "Ubah Status MT Aktif, Non Aktif dan Hapus MT.",
    tagline: "Penyesuaian status unit",
    submitLabel: "Simpan",
    type: "penonaktifan_mt"
  }
];

const panelAccentClassByAction = (actionValue) => {
  const value = String(actionValue || '').trim();
  if (value === 'Rotasi/Ganti Ban') return 'panel-accent-lav';
  if (value === 'Tambah MT') return 'panel-accent-sky';
  if (value === 'Edit Profil MT') return 'panel-accent-sky';
  if (value === 'Mutasi') return 'panel-accent-mint';
  if (value === 'Ubah Status MT') return 'panel-accent-peach';
  if (value === 'Tambal') return 'panel-accent-rose';
  if (value === 'Storing') return 'panel-accent-lav';
  return 'panel-accent-default';
};

const REQ_GROUP_WO_ODO_TD_LOAD = 'wo-odo-td-load';
const REQ_GROUP_WO_MT_PROFIL_LOAD = 'wo-mt-profil-load';
const REQ_GROUP_WO_UBAH_STATUS_SUBMIT = 'wo-ubah-status-submit';
const REQ_GROUP_WO_ROTASI_HISTORY_LOAD = 'wo-rotasi-history-load';
const REQ_GROUP_WO_ROTASI_SUBMIT = 'wo-rotasi-submit';
const REQ_GROUP_WO_MUTASI_HISTORY_LOAD = 'wo-mutasi-history-load';
const REQ_GROUP_WO_MUTASI_SUBMIT = 'wo-mutasi-submit';
const REQ_GROUP_WO_TAMBAL_HISTORY_LOAD = 'wo-tambal-history-load';
const REQ_GROUP_WO_TAMBAL_SUBMIT = 'wo-tambal-submit';
const REQ_GROUP_WO_TAMBAL_OPSI_LOAD = 'wo-tambal-opsi-load';
const REQ_GROUP_WO_GANTI_HISTORY_LOAD = 'wo-ganti-history-load';
const REQ_GROUP_WO_PASANG_MT_KOSONG_LOAD = 'wo-pasang-mt-kosong-load';
const REQ_GROUP_WO_GUDANG_BAN_LOAD = 'wo-gudang-ban-load';
const REQ_GROUP_WO_GANTI_SUBMIT = 'wo-ganti-submit';
const REQ_GROUP_WO_TAMBAH_MT_NOMOR_REF_LOAD = 'wo-tambah-mt-nomor-ref-load';

const EMPTY_ODO_TD_SUMMARY = {
  odo: { value: '-', date: null },
  td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
  banDetails: {},
  banPositionMap: {}
};
const ODO_TD_CHECK_STORE = {
  byMt: new Map(),
  inFlight: new Map()
};
const NOMOR_PREVIEW_PLACEHOLDER = '-';
const buildNomorPlaceholder = ({ kodeCabang, prefix, tanggal }) => {
  const cabang = String(kodeCabang || '').trim();
  const safePrefix = String(prefix || 'WO').trim().toUpperCase() || 'WO';
  const tgl = formatYYYYMMDD(tanggal || new Date());
  const [year = '', month = ''] = String(tgl || '').split('-');
  if (!cabang || !month || !year) return NOMOR_PREVIEW_PLACEHOLDER;
  return `${cabang}/${safePrefix}/${month}/${year}/0`;
};
const toNomorPreviewDisplay = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return NOMOR_PREVIEW_PLACEHOLDER;
  const parts = raw.split('/');
  if (parts.length < 5) return raw;
  parts[parts.length - 1] = '-';
  return parts.join('/');
};
const normalizeDateKey = (value) => {
  if (!value) return "";
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  return formatYYYYMMDD(value) || "";
};
const dateFromKeyLocal = (key) => {
  const m = String(key || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mm = Number(m[2]);
  const d = Number(m[3]);
  if (!Number.isFinite(y) || !Number.isFinite(mm) || !Number.isFinite(d)) return null;
  return new Date(y, mm - 1, d);
};
const formatDateLocalLabel = (value) => {
  const key = normalizeDateKey(value);
  if (!key) return '-';
  const date = dateFromKeyLocal(key);
  if (!date || Number.isNaN(date.getTime())) return key;
  return date.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
};
const dayDiffLabelFromKey = (value) => {
  const key = normalizeDateKey(value);
  if (!key) return '-';
  const target = dateFromKeyLocal(key);
  const today = dateFromKeyLocal(formatYYYYMMDD(new Date()));
  if (!target || !today) return '-';
  const diffDays = Math.max(0, Math.floor((today.getTime() - target.getTime()) / 86400000));
  return `${diffDays} hari lalu`;
};
const normalizeStatusText = (value) => String(value || '').trim().toUpperCase();
const parseTierStatus = (value, prefix) => {
  const raw = normalizeStatusText(value);
  const m = raw.match(new RegExp(`^${prefix}-(\\d+)$`));
  return Number(m?.[1] || 0) || 0;
};
const getStatusChangeOptions = (currentStatusRaw) => {
  const current = normalizeStatusText(currentStatusRaw);
  if (current === 'NT') return ['UT', 'VT-1', 'Casing'];
  if (current === 'UT') return ['VT-1', 'Casing'];
  if (current.startsWith('VT-')) {
    const lvl = Math.max(1, parseTierStatus(current, 'VT'));
    return [`UV-${lvl}`, `VT-${lvl + 1}`, 'Casing'];
  }
  if (current.startsWith('UV-')) {
    const lvl = Math.max(1, parseTierStatus(current, 'UV'));
    return [`VT-${lvl + 1}`, 'Casing'];
  }
  if (current === 'CASING') return ['Casing'];
  return ['Casing'];
};
const buildStatusActionOptions = (currentStatusRaw) => {
  const current = String(currentStatusRaw || '').trim();
  const base = getStatusChangeOptions(currentStatusRaw);
  const out = [];
  if (current) out.push(current);
  base.forEach((item) => {
    if (!out.some((x) => normalizeStatusText(x) === normalizeStatusText(item))) out.push(item);
  });
  return out.length ? out : ['Casing'];
};
const parseDaftarBanRaw = (raw) => {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === 'object' && parsed ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof raw === 'object' && raw ? raw : {};
};
const buildEmptyOdoTdResult = () => ({
  summary: { ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} },
  todayCheckStatus: { odo: false, td: false },
  banUpdateMap: {}
});
const loadGlobalOdoTdCheckByMt = async (idMt, selectedMT, force = false) => {
  const key = String(idMt || '').trim();
  if (!key) return buildEmptyOdoTdResult();
  if (!force && ODO_TD_CHECK_STORE.byMt.has(key)) {
    return ODO_TD_CHECK_STORE.byMt.get(key);
  }
  if (!force && ODO_TD_CHECK_STORE.inFlight.has(key)) {
    return ODO_TD_CHECK_STORE.inFlight.get(key);
  }

  const todayKey = formatYYYYMMDD(new Date());
  const requestPromise = (async () => {
    const reqGroup = `${REQ_GROUP_WO_ODO_TD_LOAD}-${key}`;
    api.cancelPendingRequests({
      group: reqGroup,
      reason: `refresh odo td mt ${key}`,
    });
    const { data: lastCheckRaw } = await api.get(`${backendPort}/api/main/load_last_check/${key}`, {
      requestGroup: reqGroup,
      timeout: 120000,
    });
    const lastCheck = (lastCheckRaw && typeof lastCheckRaw === 'object') ? lastCheckRaw : {};
    const odoRow = (lastCheck.mt_odo && typeof lastCheck.mt_odo === 'object') ? lastCheck.mt_odo : null;
    const banRows = Array.isArray(lastCheck.ban_initial) ? lastCheck.ban_initial : [];
    const kmtdRows = Array.isArray(lastCheck.ban_last_kmtd) ? lastCheck.ban_last_kmtd : [];

    let daftarBan = parseDaftarBanRaw(lastCheck?.daftar_ban || lastCheck?.mt_odo?.daftar_ban || {});
    if (!Object.keys(daftarBan).length) {
      const fromInitial = {};
      banRows.forEach((row) => {
        const posisiRaw = String(row?.posisi || '').trim();
        const posisi = posisiRaw.includes('#')
          ? String(posisiRaw.split('#').slice(1).join('#') || '').trim()
          : posisiRaw;
        const idBan = Number(row?.id_ban || 0);
        if (posisi && Number.isFinite(idBan) && idBan > 0) fromInitial[posisi] = idBan;
      });
      daftarBan = fromInitial;
    }
    const positionEntries = Object.entries(daftarBan || {})
      .filter(([, idBan]) => Number.isFinite(Number(idBan)) && Number(idBan) > 0);

    const banById = {};
    banRows.forEach((row) => {
      const idBan = Number(row?.id_ban || 0);
      if (!idBan || banById[idBan]) return;
      banById[idBan] = row;
    });
    const kmtdById = {};
    kmtdRows.forEach((row) => {
      const idBan = Number(row?.id_ban || 0);
      if (!idBan || kmtdById[idBan]) return;
      kmtdById[idBan] = row;
    });

    const sortedEntries = [...positionEntries].sort((a, b) => a[0].localeCompare(b[0]));
    const banDetails = {};
    const banPositionMap = {};
    const banUpdateMap = {};
    let terpasang = 0;
    let cadangan = 0;
    let oldestTdKey = null;
    let tdRequiredCount = 0;
    let tdUpdatedTodayCount = 0;

    sortedEntries.forEach(([posisi, idBan], idx) => {
      const idBanNum = Number(idBan) || 0;
      const rowBan = banById[idBanNum] || {};
      const rowKmtd = kmtdById[idBanNum] || {};
      const kmtDate = normalizeDateKey(rowKmtd?.tglkmt || rowKmtd?.tgl || null) || null;
      const tdDate = normalizeDateKey(rowKmtd?.tgltd || rowKmtd?.tgl || rowBan?.tanggal || null) || null;
      if (tdDate && (!oldestTdKey || tdDate < oldestTdKey)) oldestTdKey = tdDate;
      if (String(posisi).startsWith('P-')) {
        terpasang += 1;
      } else if (String(posisi).startsWith('S-')) {
        cadangan += 1;
      }
      if (idBanNum > 0) {
        tdRequiredCount += 1;
        if (tdDate === todayKey) tdUpdatedTodayCount += 1;
      }

      banDetails[posisi] = {
        posisi,
        idBan: idBanNum,
        seri: rowBan?.seri_ban || `DMY-${String(idx + 1).padStart(3, '0')}`,
        merk: rowBan?.merk || '-',
        td: rowKmtd?.td || rowBan?.td || '-',
        kmTempuh: Number(rowKmtd?.kmt || 0),
        wearRate: rowBan?.wear_rate || '0.00 mm/1.000km',
        tanggalInitial: rowBan?.tanggal_profil || rowBan?.tanggal || selectedMT?.tanggal || null,
        statusProfil: rowBan?.status_profil || '-',
        lastOdoDate: odoRow?.tanggal || null,
        lastKmtDate: kmtDate,
        lastTdDate: tdDate,
        histori: [],
      };
      banPositionMap[posisi] = idBanNum;
      banUpdateMap[posisi] = {
        odoDate: normalizeDateKey(odoRow?.tanggal || null) || null,
        kmtDate,
        tdDate
      };
    });

    const hasOdoRow = odoRow && (odoRow?.odo != null || odoRow?.kmt_mt != null);
    const odoValue = Number(odoRow?.odo || 0);
    const kmtValue = Number(odoRow?.kmt_mt || 0);
    const odoDate = hasOdoRow ? (normalizeDateKey(odoRow?.tanggal || null) || null) : null;

    const result = {
      summary: {
        odo: {
          value: hasOdoRow
            ? `${odoValue.toLocaleString('id-ID')} / ${kmtValue.toLocaleString('id-ID')} KM`
            : '- / - KM',
          date: odoDate
        },
        td: {
          terpasang,
          cadangan,
          total: terpasang + cadangan,
          oldestDate: oldestTdKey || null
        },
        banDetails,
        banPositionMap
      },
      todayCheckStatus: {
        odo: odoDate === todayKey,
        td: tdRequiredCount > 0 && tdUpdatedTodayCount === tdRequiredCount
      },
      banUpdateMap
    };
    ODO_TD_CHECK_STORE.byMt.set(key, result);
    return result;
  })()
    .finally(() => {
      ODO_TD_CHECK_STORE.inFlight.delete(key);
    });

  ODO_TD_CHECK_STORE.inFlight.set(key, requestPromise);
  return requestPromise;
};

export function PageKonten16({ authIdentity = {}, token, setPage, resendToken = 0, actionScope = 'all' }) {
  const {globalOpsi, manualResyncGlobalOpsi} = useGlobalOpsi();
  const opsiMT = globalOpsi.opsiMT;
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiBan = globalOpsi.opsiBan;
  const actorNama = String(authIdentity?.nama || "").trim();
  const actorKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const dataWOKosong = {
    nomor: '',
    tanggal: formatYYYYMMDD(new Date()),
    jenis: '',
    user: actorNama,
  };
  const [dataWO, setDataWO] = useState(dataWOKosong);
  const [activeMenu, setActiveMenu] = useState('');
  const [showEdit, setShowEdit] = useState(false);
  const [showMaster, setShowMaster] = useState(true);
  const [showRotasiBanModal, setShowRotasiBanModal] = useState(false);
  const [rotasiModalData, setRotasiModalData] = useState({});
  const [editConfig, setEditConfig] = useState({ statusAksi: 'baru', data: null, woContext: null });
  const [mtProfilMap, setMtProfilMap] = useState({});
  const [mtDetailMap, setMtDetailMap] = useState({});

  const loadNomorWO = async (prefix = 'WO') => {
    const kodeCabang = String(
      dataWO?.pengirim || (actorKodeCabang === 'C-1' ? '' : actorKodeCabang)
    ).trim();
    const nomorPlaceholder = buildNomorPlaceholder({
      kodeCabang,
      prefix,
      tanggal: dataWO?.tanggal || new Date(),
    });
    setDataWO((prev) => ({ ...prev, nomor: nomorPlaceholder }));
  };
  const isPusatUser = actorKodeCabang === 'C-1';
  const visibleActions = useMemo(() => {
    if (actionScope === 'tambal_only') return ACTIONS.filter((x) => x.value === 'Tambal');
    const baseActions = ACTIONS;
    if (!isPusatUser) {
      const pusatOnlyTypes = new Set(['mutasi']);
      return baseActions.filter((x) => !pusatOnlyTypes.has(String(x?.type || '').trim()));
    }
    return baseActions;
  }, [actionScope, isPusatUser]);
  const activeAction = visibleActions.find(action => action.value === activeMenu);

  useEffect(() => {
    const allowed = new Set(visibleActions.map((x) => x.value));
    if (allowed.has(activeMenu)) return;
    if (visibleActions.length === 1) {
      setActiveMenu(visibleActions[0].value);
      return;
    }
    setActiveMenu('');
  }, [activeMenu, visibleActions]);

  const handleOpenRotasiGantiBanModal = (payload = {}) => {
    const getMtDetail = (idMt) => {
      const id = String(idMt || '').trim();
      if (!id) return null;
      return mtDetailMap?.[id]
        || (Array.isArray(opsiMT) ? opsiMT.find((x) => String(x?.id_mt || '').trim() === id) : null)
        || null;
    };

    const kodeCabang = String(payload?.kode_cabang || '').trim();
    const nomor = String(payload?.nomor_wo || '').trim();
    const tanggal = String(payload?.tanggal_input || '').trim();
    const jumlahMt = String(payload?.jumlah_mt || '2').trim() === '2' ? '2' : '1';
    const mt1 = String(payload?.id_mt_1 || '').trim();
    const mt2 = String(payload?.id_mt_2 || '').trim();
    const start = String(payload?.start || '').trim();
    const end = String(payload?.end || '').trim();
    const mt1Detail = getMtDetail(mt1) || {};
    const mt2Detail = getMtDetail(mt2) || {};

    setRotasiModalData({
      ...(mt1Detail || {}),
      lampiran: [],
      lampiran_mt_event: '',
      id_mt: mt1 || '',
      nopol: String(payload?.nopol_1 || mt1Detail?.nopol || '').trim(),
      kode_cabang: kodeCabang,
      nomor_wo: nomor,
      tanggal_input: tanggal,
      start,
      end,
      jumlah_mt: Number(jumlahMt),
      id_mt_1: mt1 || '',
      nopol_1: String(payload?.nopol_1 || mt1Detail?.nopol || '').trim(),
      roda_1: Number(mt1Detail?.roda || 0),
      cadangan_1: Number(mt1Detail?.cadangan || 0),
      id_mt_2: mt2 || '',
      nopol_2: String(payload?.nopol_2 || mt2Detail?.nopol || '').trim(),
      roda_2: Number(mt2Detail?.roda || 0),
      cadangan_2: Number(mt2Detail?.cadangan || 0),
    });
    setShowRotasiBanModal(true);
  };

  const renderPanelBody = () => {
    if (!activeAction) return null;
    if (activeAction.type === 'initial') {
      return (
        <PanelTambahMT
          action={activeAction}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          dataWO={dataWO}
          setDataWO={setDataWO}
          setShowEdit={setShowEdit}
          setShowMaster={setShowMaster}
          setEditConfig={setEditConfig}
          authIdentity={authIdentity}
          opsiCabang={opsiCabang}
          opsiMT={opsiMT}
          mtDetailMap={mtDetailMap}
        />
      ); 
    } else if (activeAction.type === 'initial_edit') {
      return (
        <PanelEditProfilMT
          action={activeAction}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          dataWO={dataWO}
          setDataWO={setDataWO}
          setShowEdit={setShowEdit}
          setShowMaster={setShowMaster}
          setEditConfig={setEditConfig}
          authIdentity={authIdentity}
          opsiCabang={opsiCabang}
          opsiMT={opsiMT}
          mtDetailMap={mtDetailMap}
        />
      );
    } else if (activeAction.type === 'rotasi_ganti_ban') {
      return (
        <PanelRotasiGantiBan
          action={activeAction}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          dataWO={dataWO}
          setDataWO={setDataWO}
          authIdentity={authIdentity}
          opsiCabang={opsiCabang}
          opsiMT={opsiMT}
          onContinue={handleOpenRotasiGantiBanModal}
        />
      );
    } else if (activeAction.type === 'mutasi'){
      return (
        <PanelMutasiMT
        action={activeAction}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        dataWO={dataWO}
        setDataWO={setDataWO}
        opsiMT={opsiMT}
        opsiCabang={opsiCabang}
        authIdentity={authIdentity}
        loadNomorWO={loadNomorWO}
        mtProfilMap={mtProfilMap}
        mtDetailMap={mtDetailMap}
        globalOpsi={globalOpsi}
        manualResyncGlobalOpsi={manualResyncGlobalOpsi}
        resendToken={resendToken}
      />
      );
    } else if (activeAction.type === 'penonaktifan_mt') {
      return (
        <PanelPenonaktifanMT
          action={activeAction}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          dataWO={dataWO}
          setDataWO={setDataWO}
          authIdentity={authIdentity}
          loadNomorWO={loadNomorWO}
          globalOpsi={globalOpsi}
          opsiMT={opsiMT}
          opsiCabang={opsiCabang}
          mtProfilMap={mtProfilMap}
          mtDetailMap={mtDetailMap}
          manualResyncGlobalOpsi={manualResyncGlobalOpsi}
        />
      );
    } else if (activeAction.type === 'tambal') {
      return (
        <PanelTambalBan
          action={activeAction}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          dataWO={dataWO}
          setDataWO={setDataWO}
          opsiMT={opsiMT}
          opsiCabang={opsiCabang}
          authIdentity={authIdentity}
          mtProfilMap={mtProfilMap}
          mtDetailMap={mtDetailMap}
          globalOpsi={globalOpsi}
          resendToken={resendToken}
        />
      );
    } else if (activeAction.type === 'storing_irregular') {
      return (
        <PageKonten26Irregular
          authIdentity={authIdentity}
          globalOpsi={globalOpsi}
          resendToken={resendToken}
          actionScope="storing_only"
        />
      );
    }
    return (
      <PanelGeneric
        action={activeAction}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        setDataWO={setDataWO}
      />
    );
  };
  useEffect(() => {
    setDataWO((prev) => {
      const base = {
        nomor: prev?.nomor || '',
        tanggal: prev?.tanggal || formatYYYYMMDD(new Date()),
        jenis: '',
        user: actorNama || prev?.user || '',
      };

      if (activeMenu === 'Mutasi') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          penerima: '',
          mt: '',
          nopol: '',
          catatan_mt: '',
          check_validasi_mt: false,
          nama_pemeriksa_mt: actorNama || '',
        };
      }
      if (activeMenu === 'Rotasi/Ganti Ban') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          jumlah_mt: '2',
          mt_1: '',
          nopol_1: '',
          mt_2: '',
          nopol_2: '',
          start: '',
          end: '',
        };
      }

      if (activeMenu === 'Tambal') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          penerima: '',
          mt: '',
          nopol: '',
          start: '',
          end: '',
          patch_kebutuhan: 0,
          catatan_mt: '',
          check_validasi_mt: false,
          nama_pemeriksa_mt: actorNama || '',
        };
      }

      if (activeMenu === 'Tambah MT') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          start: '',
          end: '',
          mt: '',
          mt_edit: '',
        };
      }
      if (activeMenu === 'Edit Profil MT') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          mt_edit: '',
        };
      }

      if (activeAction?.type === 'penonaktifan_mt') {
        const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
        return {
          ...base,
          pengirim: defaultPengirim,
          mt: '',
          nopol: '',
          aksi_penonaktifan: 'Non Aktif',
          catatan_mt: '',
          check_validasi_mt: false,
          nama_pemeriksa_mt: actorNama || '',
        };
      }

      if (activeMenu) {
        return {
          ...base,
          servisStart: '',
          servisEnd: '',
        };
      }

      return base;
    });
  }, [activeMenu, activeAction?.type, actorKodeCabang, actorNama]);

  useEffect(() => {
    let prefixNomor = 'WO';
    if (activeMenu === 'Edit Profil MT') {
      prefixNomor = 'EDIT';
    } else if (activeAction?.type === 'penonaktifan_mt') {
      const aksi = String(dataWO?.aksi_penonaktifan || '').trim().toLowerCase();
      if (aksi === 'hapus') {
        prefixNomor = 'HAPUS';
      } else if (aksi === 'aktif' || aksi === 'aktifasi' || aksi === 'aktivasi') {
        prefixNomor = 'AKTIFASI';
      } else if (aksi === 'non aktif' || aksi === 'nonaktif') {
        prefixNomor = 'NONAKTIF';
      } else {
        prefixNomor = 'NONAKTIF';
      }
    }
    loadNomorWO(prefixNomor);
  }, [activeMenu, activeAction?.type, dataWO?.aksi_penonaktifan, dataWO?.tanggal, dataWO?.pengirim, actorKodeCabang, token, resendToken]);

  const reloadMtProfil = async () => {
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_WO_MT_PROFIL_LOAD,
        reason: 'refresh mt profil',
      });
      const { data } = await api.get(`${backendPort}/api/main/mt_profil`, {
        requestGroup: REQ_GROUP_WO_MT_PROFIL_LOAD,
        timeout: 120000,
      });
      const rows = Array.isArray(data) ? data : [];
      const mapped = {};
      rows.forEach((row) => {
        if (!row?.id_mt) return;
        mapped[row.id_mt] = {
          roda: Number(row.roda || 16),
          cadangan: Number(row.cadangan || 3),
        };
      });
      setMtProfilMap(mapped);
      const detailMap = {};
      rows.forEach((row) => {
        if (!row?.id_mt) return;
        detailMap[row.id_mt] = row;
      });
      setMtDetailMap(detailMap);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error("Gagal load mt_profil:", err);
      setMtProfilMap({});
      setMtDetailMap({});
    }
  };

  useEffect(() => {
    //reloadMtProfil();
  }, [resendToken]);

  const handleEditProfileOptimisticUpdate = (updatedMt) => {
    const idMt = String(updatedMt?.id_mt || '').trim();
    if (!idMt) return;
    setMtDetailMap((prev) => ({
      ...(prev || {}),
      [idMt]: {
        ...(prev?.[idMt] || {}),
        ...(updatedMt || {}),
      }
    }));
    setMtProfilMap((prev) => ({
      ...(prev || {}),
      [idMt]: {
        roda: Number(updatedMt?.roda || prev?.[idMt]?.roda || 16),
        cadangan: Number(updatedMt?.cadangan || prev?.[idMt]?.cadangan || 3),
      }
    }));
    setEditConfig((prev) => {
      const prevId = String(prev?.data?.id_mt || '').trim();
      if (prev?.statusAksi !== 'edit' || prevId !== idMt) return prev;
      return {
        ...prev,
        data: {
          ...(prev?.data || {}),
          ...(updatedMt || {}),
        }
      };
    });
  };
  
  return (
      <div className="container-fluid px-0 page16-wo2-table-theme page16-wo-elegant-theme">
        <div className="page16-header d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
          <div>
            <h3 className="page16-title">Work Order dan Storing</h3>
          </div>
        
        </div>

        {showMaster && <div className="row g-4">
          <div className="col-12 col-md-4">
            <div className="page16-action-grid">
              <div className="row g-2">
                {visibleActions.map(action => (
                  <div key={action.value} className="col-12">
                    <ActionButton
                      action={action}
                      activeMenu={activeMenu}
                      onClick={setActiveMenu}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8">
              <div className="d-flex flex-column">
                <div className="page16-panel-content flex-grow-1">
                  {activeAction ? (
                    renderPanelBody()
                  ) : (
                    <div className="page16-panel-placeholder d-flex flex-column justify-content-center align-items-center text-center h-100">
                      <p className="fw-semibold mb-2">Belum ada aktivitas yang dipilih.</p>
                      <p className="text-muted small">Pilih tombol di sisi kiri untuk menampilkan detail form action.</p>
                    </div>
                  )}
                </div>
              </div>
          </div>
        </div>}
        {showEdit && <PageKonten9_Edit 
              statusAksi = {editConfig?.statusAksi || 'baru'}
              data = {editConfig?.data || null}
              woContext={editConfig?.woContext || null}
              loadData = {() => Promise.resolve()} 
              setShowEdit = {setShowEdit}
              setShowMaster = {setShowMaster}
              setDataWO={setDataWO}
              authIdentity={authIdentity}
              loadNomorWO={loadNomorWO}
              onUpdated={handleEditProfileOptimisticUpdate}
        />}
        {showRotasiBanModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }}>
            <div className="modal-dialog modal-dialog-scrollable" style={{ width: '100vw', maxWidth: '100vw', height: '100vh', maxHeight: '100vh', margin: 0 }}>
              <div className="modal-content" style={{ height: '100vh', maxHeight: '100vh', borderRadius: 0 }}>
                <div className="modal-header">
                  <h5 className="modal-title mb-0">Rotasi/Ganti dan Repair Ban</h5>
                  <button type="button" className="btn-close" onClick={() => setShowRotasiBanModal(false)} />
                </div>
                <div className="modal-body" style={{ overflowY: 'auto' }}>
                  <PageKonten32_Rotasi
                    globalOpsi={globalOpsi}
                    editData={rotasiModalData}
                    authIdentity={authIdentity}
                    setShowDetail={setShowRotasiBanModal}
                    setShowMaster={() => {}}
                    onSubmitSuccess={() => {
                      setShowRotasiBanModal(false);
                      setActiveMenu('');
                    }}
                    reloadToken={resendToken}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      
      </div>
    
  );
  }
function ActionButton({ action, activeMenu, onClick }) {
  const isActive = activeMenu === action.value;

  return (
    <button
      type="button"
      className={`page15-odotd-action ${isActive ? 'is-active' : ''}`}
      onClick={() => onClick(action.value)}
    >
      <div className="d-flex justify-content-between align-items-start gap-2">
        <div>
          <h5 className="mb-1 text-white">{action.title}</h5>
          <p className="mb-0 text-white-80 small">{action.description}</p>
        </div>
        <span className="page16-action-state text-white">{isActive ? 'Aktif' : 'Pilih'}</span>
      </div>
    </button>
  );
  }
function WoMetaFields({ dataWO, setDataWO }) {
  const nomorWoDisplay = toNomorPreviewDisplay(dataWO?.nomor || '');
  return (
    <div className="row g-3 mb-3">
      <div className="col-12 col-sm-6">
        <label className="form-label">No. WO</label>
        <input type="text" className="form-control" readOnly value={nomorWoDisplay} />
      </div>
      <div className="col-12 col-sm-6">
        <label className="form-label">Tanggal</label>
        <input
          type="date"
          className="form-control"
          value={dataWO?.tanggal || ''}
          onChange={(e) => setDataWO((prev) => ({ ...prev, tanggal: e.target.value }))}
        />
      </div>
    </div>
  );
}
function ModalPickTambalBanMulti({
  open,
  onClose,
  onSubmit,
  title = "Pilih Ban Tambal",
  subtitle = "Klik ban di formasi untuk menambah/mengurangi daftar ban tambal.",
  formasi = 16,
  cadangan = 3,
  daftarKodeBan = {},
  banDetails = {},
  banEventMap = {},
  initialSelectedIds = [],
  formatDateLocal = (value) => value || "-",
}) {
  const [selectedPosisi, setSelectedPosisi] = useState([]);
  const [activePosisi, setActivePosisi] = useState("");

  useEffect(() => {
    if (!open) return;
    const selectedIdSet = new Set(
      (Array.isArray(initialSelectedIds) ? initialSelectedIds : [])
        .map((x) => Number(x))
        .filter((x) => Number.isFinite(x) && x > 0)
    );
    const posisiAwal = Object.entries(banDetails || {})
      .filter(([, detail]) => selectedIdSet.has(Number(detail?.idBan || 0)))
      .map(([pos]) => String(pos || ""))
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b));
    setSelectedPosisi(posisiAwal);
    setActivePosisi(posisiAwal[0] || "");
  }, [open, banDetails, initialSelectedIds]);

  useEffect(() => {
    if (!open) return;
    if (!selectedPosisi.length) {
      setActivePosisi("");
      return;
    }
    if (selectedPosisi.includes(activePosisi)) return;
    setActivePosisi(selectedPosisi[0] || "");
  }, [open, selectedPosisi, activePosisi]);

  if (!open) return null;

  const togglePosisi = (pos) => {
    const posisi = String(pos || "");
    const detail = banDetails?.[posisi];
    if (!detail || !Number(detail?.idBan || 0)) return;
    setSelectedPosisi((prev) => {
      const exists = prev.includes(posisi);
      if (exists) return prev.filter((x) => x !== posisi);
      return [...prev, posisi].sort((a, b) => a.localeCompare(b));
    });
    setActivePosisi(posisi);
  };

  const activeBase = banDetails?.[activePosisi] || null;
  const activeHistori = activeBase ? (banEventMap?.[Number(activeBase?.idBan || 0)] || []) : [];
  const activeLatest = activeHistori?.[0] || null;
  const activeModalBan = activeBase ? {
    posisi: String(activePosisi || "").trim(),
    seri: String(activeBase?.seri || "").trim(),
    idBan: Number(activeBase?.idBan || 0),
    merk: String(activeBase?.merk || "").trim(),
    kmt: Number(activeBase?.kmTempuh || 0),
    td: String(activeBase?.td || "").trim(),
    status: String(activeLatest?.status || activeBase?.statusProfil || "-").trim() || "-",
    histori: activeHistori,
  } : null;

  return (
    <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
      <div className="page16-modal-card page26-storing-modal" style={{ maxWidth: "50vw", width: "50vw" }}>
        <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
          <div>
            <h5 className="mb-1">{title}</h5>
            <small className="text-muted">{subtitle}</small>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              const rows = selectedPosisi.map((pos) => {
                const detail = banDetails?.[pos] || {};
                const hist = banEventMap?.[Number(detail?.idBan || 0)] || [];
                const latest = hist?.[0] || null;
                return {
                  id_ban: Number(detail?.idBan || 0),
                  seri_ban: String(detail?.seri || "").trim(),
                  status: String(latest?.status || detail?.statusProfil || "-").trim() || "-",
                  posisi: String(pos || "").trim(),
                };
              }).filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0);
              const ids = rows.map((row) => Number(row.id_ban));
              onSubmit?.(rows, ids);
              onClose?.();
            }}
          >
            Selesai
          </button>
        </div>

        <div className="row page26-storing-grid g-3 align-items-start">
          <div className="col-12 col-xl-7">
            <div className="page16-popup-formasi page26-storing-formasi">
              <FormasiBan
                formasi={Number(formasi || 16)}
                cadangan={Number(cadangan || 3)}
                onClick={togglePosisi}
                daftarKodeBan={daftarKodeBan}
                highlightedPosisi={selectedPosisi}
              />
            </div>
          </div>
          <div className="col-12 col-xl-5">
            <div className="page16-popup-detail w-100 page26-storing-selection-box">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <strong>Ban Terpilih ({selectedPosisi.length})</strong>
                {!selectedPosisi.length && <small className="text-muted">Belum ada</small>}
              </div>
              <div className="d-flex flex-wrap gap-2 mb-2">
                {selectedPosisi.map((pos) => {
                  const active = activePosisi === pos;
                  return (
                    <button
                      key={`tambal-pos-chip-${pos}`}
                      type="button"
                      className={`btn btn-sm ${active ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActivePosisi(pos)}
                    >
                      {pos}
                    </button>
                  );
                })}
              </div>

              {!!activeModalBan && (
                <div className="page26-storing-detail-panel">
                  <h6 className="mb-2">{activeModalBan.posisi} | {activeModalBan.seri || "-"}</h6>
                  <div className="row g-1 small mb-2">
                    <div className="col-6"><strong>ID Ban</strong></div><div className="col-6 text-end">{activeModalBan.idBan || "-"}</div>
                    <div className="col-6"><strong>Merk</strong></div><div className="col-6 text-end">{activeModalBan.merk || "-"}</div>
                    <div className="col-6"><strong>KMT</strong></div><div className="col-6 text-end">{Number(activeModalBan.kmt || 0).toLocaleString("id-ID")}</div>
                    <div className="col-6"><strong>TD</strong></div><div className="col-6 text-end">{activeModalBan.td || "-"}</div>
                    <div className="col-6"><strong>Status</strong></div><div className="col-6 text-end">{activeModalBan.status || "-"}</div>
                  </div>

                  <strong className="small d-block mb-1">Histori Ban</strong>
                  <div className="page16-rotasi-histori">
                    {(activeModalBan.histori || []).slice(0, 10).map((item, idx) => (
                      <div key={`tambal-modal-hist-${idx}`} className="page16-rotasi-histori-item">
                        <small className="text-muted">{formatDateLocal(item?.tanggal)} | {item?.event || "-"}</small>
                        <div className="small">{item?.catatan_ban || item?.info || "-"}</div>
                      </div>
                    ))}
                    {!activeModalBan.histori?.length && <small className="text-muted">Belum ada histori.</small>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalTambalDetail({
  open,
  row,
  opsiJenisTambal = [],
  opsiBahanTambal = [],
  onClose,
  onSave,
}) {
  const [form, setForm] = useState({
    jenis_tambal: '',
    bahan_tambal: '',
    qty_tambal: 0,
    catatan: '',
  });

  useEffect(() => {
    if (!open) return;
    setForm({
      jenis_tambal: String(row?.jenis_tambal || '').trim(),
      bahan_tambal: String(row?.bahan_tambal || '').trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      catatan: String(row?.catatan || ''),
    });
  }, [open, row]);

  const qtyTambal = Number(form.qty_tambal);
  const invalidJenisTambal = !String(form.jenis_tambal || '').trim();
  const invalidQtyTambal = !Number.isFinite(qtyTambal) || qtyTambal < 0 || qtyTambal > 4;

  if (!open) return null;

  return (
    <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
      <div className="page16-modal-card" style={{ width: 'min(720px, 94vw)' }}>
        <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
          <div>
            <h5 className="mb-1">Keterangan Tambal Ban</h5>
            <small className="text-muted">{`${String(row?.seri_ban || '-')} | ${String(row?.posisi || '-')}`}</small>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Tutup
          </button>
        </div>

        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Jenis Tambal</label>
            <select
              className={`form-select ${invalidJenisTambal ? 'field-required-invalid' : ''}`}
              value={form.jenis_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, jenis_tambal: e.target.value }))}
            >
              <option value="">Pilih Jenis Tambal</option>
              {(Array.isArray(opsiJenisTambal) ? opsiJenisTambal : []).map((item) => (
                <option key={`opsi-jenis-tambal-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Bahan Tambal</label>
            <select
              className="form-select"
              value={form.bahan_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, bahan_tambal: e.target.value }))}
            >
              <option value="">Pilih Bahan Tambal</option>
              {(Array.isArray(opsiBahanTambal) ? opsiBahanTambal : []).map((item) => (
                <option key={`opsi-bahan-tambal-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Quantity</label>
            <input
              type="number"
              min="0"
              max="4"
              step="1"
              className={`form-control ${invalidQtyTambal ? 'field-required-invalid' : ''}`}
              value={Number(form.qty_tambal || 0)}
              onChange={(e) => setForm((prev) => ({ ...prev, qty_tambal: Number(e.target.value || 0) }))}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Catatan</label>
            <textarea
              rows={2}
              className="form-control"
              placeholder="Masukkan catatan tambal ban..."
              value={form.catatan}
              onChange={(e) => setForm((prev) => ({ ...prev, catatan: e.target.value }))}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
            Batal
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={invalidJenisTambal || invalidQtyTambal}
            onClick={() => onSave?.({
              jenis_tambal: String(form.jenis_tambal || '').trim(),
              bahan_tambal: String(form.bahan_tambal || '').trim(),
              qty_tambal: Number(form.qty_tambal || 0),
              catatan: String(form.catatan || ''),
            })}
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
}

function PanelGeneric({ action, activeMenu, setActiveMenu, setDataWO }) {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const isTimeInvalid = !start || !end || start >= end;

  if (activeMenu !== action.value) return null;

  const handleSubmit = () => {
    if (!start || !end) {
      alert('Waktu mulai dan selesai wajib diisi');
      return;
    }

    if (start >= end) {
      alert('Waktu selesai harus lebih besar dari waktu mulai');
      return;
    }

    setDataWO(prev => ({
      ...prev,
      servisStart: start,
      servisEnd: end,
      jenis: action.value
    }));

    setActiveMenu('');
  };

  return (
    <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
        <div>
          <p className="page16-panel-label mb-1">Detail Aktivitas</p>
          <h4 className="page16-panel-title mb-1">{action.title}</h4>
          <p className="text-muted small mb-0">{action.description}</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      <div className="row g-3">
        <div className="col-12 col-sm-6">
          <label className="form-label">Waktu Mulai</label>
          <input type="time" className={`form-control ${isTimeInvalid ? 'field-required-invalid' : ''}`} value={start} onChange={(e) => setStart(e.target.value)} />
        </div>
        <div className="col-12 col-sm-6">
          <label className="form-label">Waktu Selesai</label>
          <input type="time" className={`form-control ${isTimeInvalid ? 'field-required-invalid' : ''}`} value={end} onChange={(e) => setEnd(e.target.value)} />
        </div>
      </div>

      <div className="d-flex flex-wrap gap-2 mt-4">
        <button type="button" className="btn btn-outline-secondary flex-grow-1" onClick={() => setActiveMenu('')}>
          Batal
        </button>
        <button type="button" className="btn btn-primary flex-grow-1" onClick={handleSubmit}>
          {action.submitLabel}
        </button>
      </div>
    </div>
  );
  }
function PanelRotasiGantiBan({ action, activeMenu, setActiveMenu, dataWO, setDataWO, authIdentity = {}, opsiCabang, opsiMT, onContinue }) {
  const { showNotif } = useNotification();
  const [showCariMt1Modal, setShowCariMt1Modal] = useState(false);
  const [showCariMt2Modal, setShowCariMt2Modal] = useState(false);
  const [showOdoUpdateModal, setShowOdoUpdateModal] = useState(false);
  const [showTdUpdateModal, setShowTdUpdateModal] = useState(false);
  const [odoTdModalTarget, setOdoTdModalTarget] = useState('mt1');
  const [loadingSummaryMt1, setLoadingSummaryMt1] = useState(false);
  const [loadingSummaryMt2, setLoadingSummaryMt2] = useState(false);
  const [summaryMt1, setSummaryMt1] = useState({ ...EMPTY_ODO_TD_SUMMARY });
  const [summaryMt2, setSummaryMt2] = useState({ ...EMPTY_ODO_TD_SUMMARY });
  const [todayCheckStatusMt1, setTodayCheckStatusMt1] = useState({ odo: false, td: false });
  const [todayCheckStatusMt2, setTodayCheckStatusMt2] = useState({ odo: false, td: false });

  const todayISO = formatYYYYMMDD(new Date());
  const formatDateLocal = formatDateLocalLabel;
  const dayDiffLabel = dayDiffLabelFromKey;
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const isPusat = actorKodeCabang === 'C-1';
  const namaCabangUser = (
    (Array.isArray(opsiCabang) ? opsiCabang : []).find((x) => String(x?.kode_cabang || '').trim() === actorKodeCabang)?.nama_cabang
    || actorKodeCabang
    || ''
  );
  const jumlahMt = String(dataWO?.jumlah_mt || '2').trim() === '2' ? '2' : '1';
  const isMtPairDuplicate = jumlahMt === '2'
    && String(dataWO?.mt_1 || '').trim()
    && String(dataWO?.mt_2 || '').trim()
    && String(dataWO?.mt_1 || '').trim() === String(dataWO?.mt_2 || '').trim();
  const mt1 = (Array.isArray(opsiMT) ? opsiMT : []).find((x) => String(x?.id_mt || '').trim() === String(dataWO?.mt_1 || '').trim()) || null;
  const mt2 = (Array.isArray(opsiMT) ? opsiMT : []).find((x) => String(x?.id_mt || '').trim() === String(dataWO?.mt_2 || '').trim()) || null;
  const hasTimes = Boolean(String(dataWO?.start || '').trim() && String(dataWO?.end || '').trim() && String(dataWO?.start || '') < String(dataWO?.end || ''));
  const hasMt = jumlahMt === '2'
    ? Boolean(String(dataWO?.mt_1 || '').trim() && String(dataWO?.mt_2 || '').trim() && !isMtPairDuplicate)
    : Boolean(String(dataWO?.mt_1 || '').trim());
  const isCoreValid = Boolean(
    String(dataWO?.pengirim || '').trim()
    && String(dataWO?.nomor || '').trim()
    && String(dataWO?.tanggal || '').trim()
    && hasTimes
    && hasMt
  );
  const mt1Id = String(dataWO?.mt_1 || '').trim();
  const mt2Id = String(dataWO?.mt_2 || '').trim();
  const showMt1LastCheck = Boolean(mt1Id);
  const showMt2LastCheck = jumlahMt === '2' && Boolean(mt2Id);
  const mt1Ready = showMt1LastCheck && todayCheckStatusMt1.odo && todayCheckStatusMt1.td;
  const mt2Ready = jumlahMt === '2' ? (showMt2LastCheck && todayCheckStatusMt2.odo && todayCheckStatusMt2.td) : true;
  const canContinue = isCoreValid && mt1Ready && mt2Ready;
  const invalidPengirim = isPusat && !String(dataWO?.pengirim || '').trim();
  const invalidMt1 = !String(dataWO?.mt_1 || '').trim();
  const invalidMt2 = jumlahMt === '2' && !String(dataWO?.mt_2 || '').trim();
  const invalidTimes = !hasTimes;

  const loadLastCheckSummary = async (idMt, {
    setLoading,
    setSummary,
    setTodayCheck,
    force = false
  } = {}) => {
    const id = String(idMt || '').trim();
    if (!id) {
      setSummary?.({ ...EMPTY_ODO_TD_SUMMARY });
      setTodayCheck?.({ odo: false, td: false });
      return;
    }
    setLoading?.(true);
    setSummary?.({ ...EMPTY_ODO_TD_SUMMARY });
    setTodayCheck?.({ odo: false, td: false });
    try {
      const selectedMT = (Array.isArray(opsiMT) ? opsiMT : [])
        .find((x) => String(x?.id_mt || '').trim() === id) || null;
      const result = await loadGlobalOdoTdCheckByMt(id, selectedMT, force);
      setSummary?.(result.summary);
      setTodayCheck?.(result.todayCheckStatus);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      setSummary?.({ ...EMPTY_ODO_TD_SUMMARY });
      setTodayCheck?.({ odo: false, td: false });
    } finally {
      setLoading?.(false);
    }
  };

  const handleOdoTdSaved = () => {
    if (odoTdModalTarget === 'mt2') {
      if (!mt2Id) return;
      loadLastCheckSummary(mt2Id, {
        setLoading: setLoadingSummaryMt2,
        setSummary: setSummaryMt2,
        setTodayCheck: setTodayCheckStatusMt2,
        force: true
      });
      return;
    }
    if (!mt1Id) return;
    loadLastCheckSummary(mt1Id, {
      setLoading: setLoadingSummaryMt1,
      setSummary: setSummaryMt1,
      setTodayCheck: setTodayCheckStatusMt1,
      force: true
    });
  };

  const handleContinue = () => {
    if (!isCoreValid) {
      showNotif('error', 'Lengkapi data utama terlebih dahulu sebelum melanjutkan.');
      return;
    }
    if (!mt1Ready || !mt2Ready) {
      showNotif('error', 'Last Check ODO dan TD semua MT wajib update per hari ini.');
      return;
    }
    if (typeof onContinue === 'function') {
      onContinue({
        kode_cabang: String(dataWO?.pengirim || '').trim(),
        nomor_wo: String(dataWO?.nomor || '').trim(),
        tanggal_input: String(dataWO?.tanggal || '').trim(),
        start: String(dataWO?.start || '').trim(),
        end: String(dataWO?.end || '').trim(),
        jumlah_mt: Number(jumlahMt),
        id_mt_1: mt1Id,
        nopol_1: String(dataWO?.nopol_1 || mt1?.nopol || '').trim(),
        id_mt_2: mt2Id,
        nopol_2: String(dataWO?.nopol_2 || mt2?.nopol || '').trim(),
      });
    }
  };

  useEffect(() => {
    setDataWO((prev) => ({
      ...prev,
      jenis: action.value,
      jumlah_mt: String(prev?.jumlah_mt || '2').trim() === '2' ? '2' : '1',
      pengirim: String(prev?.pengirim || '').trim() || (isPusat ? '' : actorKodeCabang),
    }));
  }, [action.value, actorKodeCabang, isPusat, setDataWO]);

  useEffect(() => {
    if (!mt1Id) {
      setSummaryMt1({ ...EMPTY_ODO_TD_SUMMARY });
      setTodayCheckStatusMt1({ odo: false, td: false });
      return;
    }
    loadLastCheckSummary(mt1Id, {
      setLoading: setLoadingSummaryMt1,
      setSummary: setSummaryMt1,
      setTodayCheck: setTodayCheckStatusMt1
    });
  }, [mt1Id]);

  useEffect(() => {
    if (!showMt2LastCheck) {
      setSummaryMt2({ ...EMPTY_ODO_TD_SUMMARY });
      setTodayCheckStatusMt2({ odo: false, td: false });
      return;
    }
    loadLastCheckSummary(mt2Id, {
      setLoading: setLoadingSummaryMt2,
      setSummary: setSummaryMt2,
      setTodayCheck: setTodayCheckStatusMt2
    });
  }, [mt2Id, showMt2LastCheck]);

  if (activeMenu !== action.value) return null;

  return (
    <>
      <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
        <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
          <div>
            <p className="page16-panel-label mb-1">Detail Aktivitas</p>
            <h4 className="page16-panel-title mb-1">{action.title}</h4>
            <p className="text-muted small mb-0">{action.description}</p>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>

        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Cabang</label>
            {!isPusat ? (
              <input className="form-control" value={namaCabangUser || ''} readOnly />
            ) : (
              <select
                className={`form-select ${invalidPengirim ? 'field-required-invalid' : ''}`}
                value={dataWO?.pengirim ?? ''}
                onChange={(e) => setDataWO((prev) => ({
                  ...prev,
                  pengirim: e.target.value,
                  mt_1: '',
                  nopol_1: '',
                  mt_2: '',
                  nopol_2: '',
                }))}
              >
                <option value="">-Pilih Cabang-</option>
                {(Array.isArray(opsiCabang) ? opsiCabang : []).map((x) => (
                  <option key={x.kode_cabang} value={x.kode_cabang}>
                    {x.nama_cabang}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Nomor Transaksi</label>
            <input type="text" className="form-control" value={toNomorPreviewDisplay(dataWO?.nomor || '')} readOnly />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Tanggal Input</label>
            <input type="date" className="form-control" value={dataWO?.tanggal || ''} readOnly />
          </div>
        </div>
        {isMtPairDuplicate && (
          <div className="mt-2">
            <small className="text-danger fw-semibold">MT 1 dan MT 2 tidak boleh sama.</small>
          </div>
        )}

        <div className="row g-3 mt-1">
          <div className="col-12 col-md-4">
            <label className="form-label d-block">Jumlah MT terkait</label>
            <div className="d-flex gap-2 mt-2">
              <button
                type="button"
                className={`btn btn-sm ${jumlahMt === '1' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setDataWO((prev) => ({ ...prev, jumlah_mt: '1', mt_2: '', nopol_2: '' }))}
              >
                1 MT
              </button>
              <button
                type="button"
                className={`btn btn-sm ${jumlahMt === '2' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setDataWO((prev) => ({ ...prev, jumlah_mt: '2' }))}
              >
                2 MT
              </button>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Pilih MT 1</label>
            <input
              type="text"
              className={`form-control ${invalidMt1 ? 'field-required-invalid' : ''}`}
              readOnly
              style={{ cursor: 'pointer' }}
              placeholder="Pilih NoPol MT 1"
              value={String(dataWO?.nopol_1 || mt1?.nopol || '').trim()}
              onClick={() => {
                if (!String(dataWO?.pengirim || '').trim()) {
                  alert('Pilih cabang terlebih dahulu.');
                  return;
                }
                setShowCariMt1Modal(true);
              }}
            />
          </div>
          {jumlahMt === '2' && (
            <div className="col-12 col-md-4">
              <label className="form-label">Pilih MT 2</label>
              <input
                type="text"
                className={`form-control ${invalidMt2 ? 'field-required-invalid' : ''}`}
                readOnly
                style={{ cursor: 'pointer' }}
                placeholder="Pilih NoPol MT 2"
                value={String(dataWO?.nopol_2 || mt2?.nopol || '').trim()}
                onClick={() => {
                  if (!String(dataWO?.pengirim || '').trim()) {
                    alert('Pilih cabang terlebih dahulu.');
                    return;
                  }
                  setShowCariMt2Modal(true);
                }}
              />
            </div>
          )}
        </div>

        <div className="row g-3 mt-1">
          <div className="col-12 col-md-4" />
          <div className="col-12 col-md-4">
            <label className="form-label">Waktu Mulai</label>
            <input
              type="time"
              className={`form-control ${invalidTimes ? 'field-required-invalid' : ''}`}
              value={dataWO?.start || ''}
              onChange={(e) => setDataWO((prev) => ({ ...prev, start: e.target.value }))}
            />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Waktu Selesai</label>
            <input
              type="time"
              className={`form-control ${invalidTimes ? 'field-required-invalid' : ''}`}
              value={dataWO?.end || ''}
              onChange={(e) => setDataWO((prev) => ({ ...prev, end: e.target.value }))}
            />
          </div>
        </div>

        {(showMt1LastCheck || showMt2LastCheck) && (
          <div className="row g-3 mt-1">
            {showMt1LastCheck && (
              <div className={showMt2LastCheck ? 'col-12 col-lg-6' : 'col-12'}>
                <div className="card page16-info-card h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="page16-info-title">Last Check</span>
                      <span className="badge text-bg-light">{String(dataWO?.nopol_1 || mt1?.nopol || '').trim() || 'Belum pilih MT 1'}</span>
                    </div>
                    {showMt2LastCheck ? (
                      <div className="d-grid gap-2">
                        <button
                          type="button"
                          className="btn page16-gradient-btn text-white fw-bold"
                          onClick={() => {
                            setOdoTdModalTarget('mt1');
                            setShowOdoUpdateModal(true);
                          }}
                        >
                          {loadingSummaryMt1 ? 'Memuat ODO...' : `ODO: ${summaryMt1?.odo?.value ?? '-'}`}
                        </button>
                        <span className={`small ${todayCheckStatusMt1.odo ? 'text-success' : 'text-danger'}`}>
                          {formatDateLocal(todayCheckStatusMt1.odo ? todayISO : summaryMt1?.odo?.date)} ({dayDiffLabel(todayCheckStatusMt1.odo ? todayISO : summaryMt1?.odo?.date)})
                        </span>
                        <button
                          type="button"
                          className="btn page16-gradient-btn text-white fw-bold"
                          onClick={() => {
                            setOdoTdModalTarget('mt1');
                            setShowTdUpdateModal(true);
                          }}
                        >
                          {loadingSummaryMt1 ? 'Memuat TD...' : `TD: ${summaryMt1?.td?.terpasang ?? 0} + ${summaryMt1?.td?.cadangan ?? 0} ban`}
                        </button>
                        <span className={`small ${todayCheckStatusMt1.td ? 'text-success' : 'text-danger'}`}>
                          {formatDateLocal(todayCheckStatusMt1.td ? todayISO : summaryMt1?.td?.oldestDate)} ({dayDiffLabel(todayCheckStatusMt1.td ? todayISO : summaryMt1?.td?.oldestDate)})
                        </span>
                      </div>
                    ) : (
                      <div className="row g-2">
                        <div className="col-12 col-md-6">
                          <div className="d-grid gap-1">
                            <button
                              type="button"
                              className="btn page16-gradient-btn text-white fw-bold"
                              onClick={() => {
                                setOdoTdModalTarget('mt1');
                                setShowOdoUpdateModal(true);
                              }}
                            >
                              {loadingSummaryMt1 ? 'Memuat ODO...' : `ODO: ${summaryMt1?.odo?.value ?? '-'}`}
                            </button>
                            <span className={`small ${todayCheckStatusMt1.odo ? 'text-success' : 'text-danger'}`}>
                              {formatDateLocal(todayCheckStatusMt1.odo ? todayISO : summaryMt1?.odo?.date)} ({dayDiffLabel(todayCheckStatusMt1.odo ? todayISO : summaryMt1?.odo?.date)})
                            </span>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="d-grid gap-1">
                            <button
                              type="button"
                              className="btn page16-gradient-btn text-white fw-bold"
                              onClick={() => {
                                setOdoTdModalTarget('mt1');
                                setShowTdUpdateModal(true);
                              }}
                            >
                              {loadingSummaryMt1 ? 'Memuat TD...' : `TD: ${summaryMt1?.td?.terpasang ?? 0} + ${summaryMt1?.td?.cadangan ?? 0} ban`}
                            </button>
                            <span className={`small ${todayCheckStatusMt1.td ? 'text-success' : 'text-danger'}`}>
                              {formatDateLocal(todayCheckStatusMt1.td ? todayISO : summaryMt1?.td?.oldestDate)} ({dayDiffLabel(todayCheckStatusMt1.td ? todayISO : summaryMt1?.td?.oldestDate)})
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showMt2LastCheck && (
              <div className="col-12 col-lg-6">
                <div className="card page16-info-card h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="page16-info-title">Last Check</span>
                      <span className="badge text-bg-light">{String(dataWO?.nopol_2 || mt2?.nopol || '').trim() || 'Belum pilih MT 2'}</span>
                    </div>
                    <div className="d-grid gap-2">
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white fw-bold"
                        onClick={() => {
                          setOdoTdModalTarget('mt2');
                          setShowOdoUpdateModal(true);
                        }}
                      >
                        {loadingSummaryMt2 ? 'Memuat ODO...' : `ODO: ${summaryMt2?.odo?.value ?? '-'}`}
                      </button>
                      <span className={`small ${todayCheckStatusMt2.odo ? 'text-success' : 'text-danger'}`}>
                        {formatDateLocal(todayCheckStatusMt2.odo ? todayISO : summaryMt2?.odo?.date)} ({dayDiffLabel(todayCheckStatusMt2.odo ? todayISO : summaryMt2?.odo?.date)})
                      </span>
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white fw-bold"
                        onClick={() => {
                          setOdoTdModalTarget('mt2');
                          setShowTdUpdateModal(true);
                        }}
                      >
                        {loadingSummaryMt2 ? 'Memuat TD...' : `TD: ${summaryMt2?.td?.terpasang ?? 0} + ${summaryMt2?.td?.cadangan ?? 0} ban`}
                      </button>
                      <span className={`small ${todayCheckStatusMt2.td ? 'text-success' : 'text-danger'}`}>
                        {formatDateLocal(todayCheckStatusMt2.td ? todayISO : summaryMt2?.td?.oldestDate)} ({dayDiffLabel(todayCheckStatusMt2.td ? todayISO : summaryMt2?.td?.oldestDate)})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
            Batal
          </button>
          <button type="button" className="btn btn-primary" onClick={handleContinue} disabled={!canContinue}>
            Lanjutkan
          </button>
        </div>
      </div>

      <ModalCariMT
        open={showCariMt1Modal}
        onClose={() => setShowCariMt1Modal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || '').trim();
          const nopol = String(mt?.nopol || '').trim();
          if (!idMt) return;
          if (idMt === String(dataWO?.mt_2 || '').trim()) {
            alert('MT 1 tidak boleh sama dengan MT 2.');
            return;
          }
          setDataWO((prev) => ({ ...prev, mt_1: idMt, nopol_1: nopol }));
          setShowCariMt1Modal(false);
        }}
        globalOpsi={{ opsiMT }}
        kodeCabang={String(dataWO?.pengirim || '').trim()}
      />
      {jumlahMt === '2' && (
        <ModalCariMT
          open={showCariMt2Modal}
          onClose={() => setShowCariMt2Modal(false)}
          showNotif={showNotif}
          onSelect={(mt) => {
            const idMt = String(mt?.id_mt || '').trim();
            const nopol = String(mt?.nopol || '').trim();
            if (!idMt) return;
            if (idMt === String(dataWO?.mt_1 || '').trim()) {
              alert('MT 2 tidak boleh sama dengan MT 1.');
              return;
            }
            setDataWO((prev) => ({ ...prev, mt_2: idMt, nopol_2: nopol }));
            setShowCariMt2Modal(false);
          }}
          globalOpsi={{ opsiMT }}
          kodeCabang={String(dataWO?.pengirim || '').trim()}
        />
      )}
      {showOdoUpdateModal && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: 'min(1100px, 96vw)' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="odo"
              presetMtId={odoTdModalTarget === 'mt2' ? mt2Id : mt1Id}
              presetKodeCabang={String(dataWO?.pengirim || actorKodeCabang || '').trim()}
              presetTanggal={todayISO}
              onClose={() => setShowOdoUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}
      {showTdUpdateModal && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '97vw' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="td"
              presetMtId={odoTdModalTarget === 'mt2' ? mt2Id : mt1Id}
              presetKodeCabang={String(dataWO?.pengirim || actorKodeCabang || '').trim()}
              presetTanggal={todayISO}
              onClose={() => setShowTdUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}
    </>
  );
}
function PanelTambahMT({ action, activeMenu, setActiveMenu, dataWO, setDataWO, setShowMaster, setShowEdit, setEditConfig, authIdentity = {}, opsiCabang }) {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const isPusat = actorKodeCabang === 'C-1';
  const namaCabangUser = (
    (Array.isArray(opsiCabang) ? opsiCabang : []).find((x) => String(x?.kode_cabang || '').trim() === actorKodeCabang)?.nama_cabang
    || actorKodeCabang
    || ''
  );
  useEffect(()=>{
    setDataWO(prev=>({...prev, start :'', end :'', mt: ''}));
  },[]);
  if (activeMenu !== action.value) return null;
  const invalidCabangTambahMt = !String(dataWO?.pengirim || '').trim();
  const invalidTimeTambahMt = (!start || !end || start >= end);
  const handleSubmit = async () => {
    if (!String(dataWO?.pengirim || '').trim()) {
      alert('Pilih cabang terlebih dahulu.');
      return;
    }
    if (!start || !end) {
      alert('Waktu mulai dan selesai wajib diisi');
      return;
    }

    if (start >= end) {
      alert('Waktu selesai harus lebih besar dari waktu mulai');
      return;
    }

    if (dataWO.nomor === '') {
      alert('DataWO belum tersedia.');
      return;
    }

    setEditConfig({
      statusAksi: 'baru',
      data: null,
      woContext: {
        nomorWO: String(dataWO?.nomor || '').trim(),
        nomorWOEdit: '',
        dataWO: {
          start,
          end,
          jenisWO: 'initial',
          statusAksi: 'baru',
          kode_cabang: String(dataWO?.pengirim || '').trim(),
          pengirim: String(dataWO?.pengirim || '').trim(),
        },
      },
    });
    //setPage('Page9_Edit');
    setActiveMenu('');
    setShowMaster(false);
    setShowEdit(true);
  };

  return (
    <>
    <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
        <div>
          <p className="page16-panel-label mb-1">Detail Aktivitas</p>
          <h4 className="page16-panel-title mb-1">{action.title}</h4>
          <p className="text-muted small mb-0">{action.description}</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>
      <div className="row g-3">
        <div className="col-12 col-md-4">
          <label className="form-label">Cabang</label>
          {!isPusat ? (
            <input className="form-control" value={namaCabangUser || ''} readOnly />
          ) : (
            <select
              className={`form-select ${invalidCabangTambahMt ? 'field-required-invalid' : ''}`}
              value={dataWO?.pengirim ?? ''}
              onChange={(e) => setDataWO((prev) => ({
                ...prev,
                pengirim: e.target.value,
                mt_edit: '',
              }))}
            >
              <option value="">-Pilih Cabang-</option>
              {(Array.isArray(opsiCabang) ? opsiCabang : []).map((x) => (
                <option key={x.kode_cabang} value={x.kode_cabang}>
                  {x.nama_cabang}
                </option>
              ))}
            </select>
          )}
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Nomor Transaksi</label>
          <input type="text" className="form-control" readOnly value={toNomorPreviewDisplay(dataWO?.nomor || '')} />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Tanggal Input</label>
          <input
            type="date"
            className="form-control"
            value={dataWO?.tanggal || ''}
            readOnly
          />
        </div>
      </div>

      <div className="row g-3 mt-1">
        <div className="col-12 col-md-4">
          <label className="form-label">Waktu Mulai</label>
          <input
            type="time"
            className={`form-control ${invalidTimeTambahMt ? 'field-required-invalid' : ''}`}
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Waktu Selesai</label>
          <input
            type="time"
            className={`form-control ${invalidTimeTambahMt ? 'field-required-invalid' : ''}`}
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </div>
      </div>

      <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
        <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
          Batal
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
          {action.submitLabel}
        </button>
      </div>
    </div>
    </>
  );
}

function PanelEditProfilMT({ action, activeMenu, setActiveMenu, dataWO, setDataWO, setShowMaster, setShowEdit, setEditConfig, authIdentity = {}, opsiCabang, opsiMT, mtDetailMap }) {
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const isPusat = actorKodeCabang === 'C-1';
  const namaCabangUser = (
    (Array.isArray(opsiCabang) ? opsiCabang : []).find((x) => String(x?.kode_cabang || '').trim() === actorKodeCabang)?.nama_cabang
    || actorKodeCabang
  );
  const [showCariMtEditModal, setShowCariMtEditModal] = useState(false);
  const [nomorInitialMigrasiMtEvent, setNomorInitialMigrasiMtEvent] = useState('');
  const [pendingInitialNomor, setPendingInitialNomor] = useState('');
  const [isPendingInitialFlow, setIsPendingInitialFlow] = useState(false);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);
  useEffect(()=>{
    setDataWO(prev=>({...prev, mt_edit: ''}));
  },[]);
  useEffect(() => {
    const idMt = String(dataWO?.mt_edit || '').trim();
    if (!idMt) {
      setNomorInitialMigrasiMtEvent('');
      setPendingInitialNomor('');
      setIsPendingInitialFlow(false);
      setSelectedMtDetail(null);
      return;
    }
    let alive = true;
    const loadMtDetail = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_MT_PROFIL_LOAD,
          reason: `refresh mt profil by id ${idMt}`,
        });
        const { data: rows } = await api.get(`${backendPort}/api/main/mt_profil`, {
          params: { id_mt: idMt },
          requestGroup: REQ_GROUP_WO_MT_PROFIL_LOAD,
          timeout: 120000,
        });
        if (!alive) return;
        const row = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
        setSelectedMtDetail(row);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat detail MT terpilih:', err);
        setSelectedMtDetail(null);
      }
    };
    const loadNomorRef = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_TAMBAH_MT_NOMOR_REF_LOAD,
          reason: `refresh nomor initial/migrasi mt ${idMt}`,
        });
        const { data } = await api.get(
          `${backendPort}/api/main/load_mt_nomor_initial_migrasi/${encodeURIComponent(idMt)}`,
          {
            requestGroup: REQ_GROUP_WO_TAMBAH_MT_NOMOR_REF_LOAD,
            timeout: 15000,
          }
        );
        if (!alive) return;
        const nomor = String(data?.nomor || '').trim();
        setNomorInitialMigrasiMtEvent(nomor);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat nomor initial/migrasi MT:', err);
        setNomorInitialMigrasiMtEvent('');
      }
    };
    const loadPendingInitialRecord = async () => {
      try {
        const { data } = await api.get(
          `${backendPort}/api/main/load_mt_initial_pending_record/${encodeURIComponent(idMt)}`,
          { timeout: 15000 }
        );
        if (!alive) return;
        const nomorPending = String(data?.nomor || '').trim();
        const isPending = Boolean(data?.is_pending_initial);
        setPendingInitialNomor(nomorPending);
        setIsPendingInitialFlow(isPending);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat pending initial MT:', err);
        setPendingInitialNomor('');
        setIsPendingInitialFlow(false);
      }
    };
    loadMtDetail();
    loadNomorRef();
    loadPendingInitialRecord();
    return () => {
      alive = false;
    };
  }, [dataWO?.mt_edit]);
  if (activeMenu !== action.value) return null;
  const opsiMtByCabang = (Array.isArray(opsiMT) ? opsiMT : [])
    .filter((x) => String(x?.kode_cabang || '').trim() === String(dataWO?.pengirim || '').trim())
    .sort((a, b) => String(a?.nopol || '').localeCompare(String(b?.nopol || '')));
  const selectedMtEdit = opsiMtByCabang.find((x) => String(x?.id_mt || '') === String(dataWO?.mt_edit || '')) || null;
  const nomorWoInitialMigrasi = String(
    nomorInitialMigrasiMtEvent
    || selectedMtDetail?.nomor_initial_migrasi
    || (mtDetailMap?.[String(dataWO?.mt_edit || '').trim()]?.nomor_initial_migrasi)
    || selectedMtEdit?.nomor_initial_migrasi
    || ''
  ).trim();
  const nomorTransaksiPanel = isPendingInitialFlow
    ? (pendingInitialNomor || nomorWoInitialMigrasi || String(dataWO?.nomor || '').trim())
    : String(dataWO?.nomor || '').trim();
  const invalidCabang = !String(dataWO?.pengirim || '').trim();
  const invalidEditMt = !String(dataWO?.mt_edit || '').trim();
  const handleSubmit = async () => {
    if (invalidCabang) {
      alert('Pilih cabang terlebih dahulu.');
      return;
    }
    const idMt = String(dataWO?.mt_edit || '').trim();
    const nomorWoEdit = String(dataWO?.nomor || '').trim();
    if (!idMt) {
      alert('Pilih MT terlebih dahulu untuk edit profil.');
      return;
    }
    if (!nomorWoEdit) {
      alert('Nomor record EDIT belum tersedia.');
      return;
    }
    const detail = selectedMtDetail || mtDetailMap?.[idMt] || selectedMtEdit || null;
    if (!detail) {
      alert('Detail MT tidak ditemukan.');
      return;
    }
    if (!nomorWoInitialMigrasi) {
      alert('Nomor WO initial/migrasi MT belum tersedia.');
      return;
    }
    const catatanFromEvent = String(detail?.catatan_mt_event ?? '');
    const detailWithEditCatatan = {
      ...detail,
      catatan_mt: catatanFromEvent || String(detail?.catatan_mt ?? ''),
    };
    setEditConfig({
      statusAksi: 'edit',
      data: detailWithEditCatatan,
      woContext: {
        nomorWO: isPendingInitialFlow ? nomorTransaksiPanel : nomorWoInitialMigrasi,
        nomorWOEdit: isPendingInitialFlow ? '' : nomorWoEdit,
        dataWO: null,
      },
    });
    setActiveMenu('');
    setShowMaster(false);
    setShowEdit(true);
  };
  return (
    <>
      <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
        <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
          <div>
            <p className="page16-panel-label mb-1">Detail Aktivitas</p>
            <h4 className="page16-panel-title mb-1">EDIT PROFIL MT</h4>
            <p className="text-muted small mb-0">{action.description}</p>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Cabang</label>
            {!isPusat ? (
              <input className="form-control" value={namaCabangUser || ''} readOnly />
            ) : (
              <select
                className={`form-select ${invalidCabang ? 'field-required-invalid' : ''}`}
                value={dataWO?.pengirim ?? ''}
                onChange={(e) => setDataWO((prev) => ({
                  ...prev,
                  pengirim: e.target.value,
                  mt_edit: '',
                }))}
              >
                <option value="">-Pilih Cabang-</option>
                {(Array.isArray(opsiCabang) ? opsiCabang : []).map((x) => (
                  <option key={x.kode_cabang} value={x.kode_cabang}>
                    {x.nama_cabang}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Nomor Transaksi</label>
            <input type="text" className="form-control" readOnly value={toNomorPreviewDisplay(nomorTransaksiPanel)} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Tanggal Input</label>
            <input type="date" className="form-control" value={dataWO?.tanggal || ''} readOnly />
          </div>
        </div>
        <div className="row g-3 mt-1">
          <div className="col-12 col-md-4">
            <label className="form-label">Pilih MT</label>
            <input
              type="text"
              className={`form-control ${invalidEditMt ? 'field-required-invalid' : ''}`}
              readOnly
              style={{ cursor: "pointer" }}
              placeholder="Pilih NoPol MT"
              value={selectedMtEdit?.nopol || ''}
              onClick={() => {
                if (!String(dataWO?.pengirim || '').trim()) {
                  alert('Pilih cabang terlebih dahulu.');
                  return;
                }
                setShowCariMtEditModal(true);
              }}
            />
          </div>
          {isPendingInitialFlow && (
            <div className="col-12 col-md-4">
              <label className="form-label">No. Transaksi Initial</label>
              <input
                type="text"
                className="form-control"
                value={pendingInitialNomor || nomorWoInitialMigrasi || '-'}
                readOnly
              />
            </div>
          )}
        </div>
        {isPendingInitialFlow && (
          <div className="mt-2">
            <p className="mb-0 text-warning-emphasis">Proses input data MT baru Belum Selesai.</p>
          </div>
        )}
        <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
            Batal
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            {action.submitLabel}
          </button>
        </div>
      </div>
      <ModalCariMT
        open={showCariMtEditModal}
        onClose={() => setShowCariMtEditModal(false)}
        onSelect={(mt) => {
          setDataWO((prev) => ({ ...prev, mt_edit: mt.id_mt }));
        }}
        title="Pilih No. Pol MT"
        globalOpsi={{
          opsiCabang: Array.isArray(opsiCabang) ? opsiCabang : [],
          opsiMT: Array.isArray(opsiMT) ? opsiMT : []
        }}
        kodeCabang={String(dataWO?.pengirim || '').trim()}
      />
    </>
  );
}
function PanelPenonaktifanMT({ action, activeMenu, setActiveMenu, dataWO, setDataWO, authIdentity = {}, loadNomorWO, globalOpsi, opsiMT, opsiCabang, mtProfilMap, mtDetailMap, manualResyncGlobalOpsi }) {
  const { showNotif } = useNotification();
  const { showConfirm } = useConfirm();
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const actorNama = String(authIdentity?.nama || '').trim();
  const isPusatUser = actorKodeCabang === 'C-1';
  const [attachments, setAttachments] = useState([]);
  const [invalidCaptionIndexes, setInvalidCaptionIndexes] = useState([]);
  const [isLampiranInvalid, setIsLampiranInvalid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCariMtModal, setShowCariMtModal] = useState(false);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [summary, setSummary] = useState({
    odo: { value: '-', date: null },
    td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
    banDetails: {},
    banPositionMap: {}
  });
  const [todayCheckStatus, setTodayCheckStatus] = useState({ odo: false, td: false });
  const [showOdoUpdateModal, setShowOdoUpdateModal] = useState(false);
  const [showTdUpdateModal, setShowTdUpdateModal] = useState(false);
  const [showMtDetailModal, setShowMtDetailModal] = useState(false);
  const [mtDetailData, setMtDetailData] = useState(null);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);
  const todayISO = formatYYYYMMDD(new Date());
  const formatDateLocal = formatDateLocalLabel;
  const dayDiffLabel = dayDiffLabelFromKey;
  const hasSelectedMt = Boolean(dataWO?.mt);
  const hasSelectedAksi = Boolean(String(dataWO?.aksi_penonaktifan || '').trim());
  const hasValidNomorTransaksi = String(dataWO?.nomor || '').trim() !== '';
  const canShowDetailSection = Boolean(hasSelectedMt && hasValidNomorTransaksi);
  const canSubmit = Boolean(canShowDetailSection && hasSelectedAksi && todayCheckStatus.odo && todayCheckStatus.td);
  const collectInvalidCaptionIndexes = () => (
    (Array.isArray(attachments) ? attachments : [])
      .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  const invalidMtPenonaktifan = !hasSelectedMt;
  const invalidAksiPenonaktifan = !hasSelectedAksi;
  const getSelectedMT = () => (Array.isArray(opsiMT) ? opsiMT : []).find((x) => x.id_mt === dataWO?.mt) || null;
  const mtProfilRow = selectedMtDetail || mtDetailMap?.[String(dataWO?.mt || '').trim()] || null;
  const statusMtRaw = String(
    mtProfilRow?.status
    || mtProfilRow?.status_mt
    || mtProfilRow?.statusMT
    || ''
  ).trim();
  const statusMtKey = (() => {
    const raw = statusMtRaw.toUpperCase().replace(/\s+/g, ' ').trim();
    if (raw.includes('HAPUS')) return 'hapus';
    if (raw.includes('NON') && raw.includes('AKTIF')) return 'non_aktif';
    return 'aktif';
  })();
  const opsiJenisAksi = useMemo(() => {
    const base = (() => {
      if (statusMtKey === 'non_aktif') return ['Aktifasi', 'Hapus'];
      if (statusMtKey === 'hapus') return ['Aktifasi', 'Non Aktif'];
      return ['Non Aktif', 'Hapus'];
    })();
    if (isPusatUser) return base;
    return base.filter((item) => String(item || '').trim().toLowerCase() !== 'hapus');
  }, [statusMtKey, isPusatUser]);
  const loadLastCheckSummary = async (idMt, force = false) => {
    if (!idMt) {
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
      return;
    }

    setLoadingSummary(true);
    setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
    setTodayCheckStatus({ odo: false, td: false });
    try {
      const result = await loadGlobalOdoTdCheckByMt(idMt, getSelectedMT(), force);
      setSummary(result.summary);
      setTodayCheckStatus(result.todayCheckStatus);
    } catch (error) {
      if (api.isCanceledError(error)) return;
      console.error(error);
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
    } finally {
      setLoadingSummary(false);
    }
  };
  const handleOdoTdSaved = () => {
    if (!dataWO?.mt) return;
    loadLastCheckSummary(dataWO.mt, true);
  };
  const buildMtDetailData = () => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) return null;
    const row = selectedMtDetail || mtDetailMap?.[idMt] || {};
    const selected = getSelectedMT() || {};
    const profil = {
      roda: Number(row?.roda || mtProfilMap?.[idMt]?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || mtProfilMap?.[idMt]?.cadangan || selected?.cadangan || 0),
    };
    return {
      id_mt: row?.id_mt || selected?.id_mt || idMt,
      nopol: row?.nopol || selected?.nopol || '-',
      kode_cabang: row?.kode_cabang || selected?.kode_cabang || dataWO?.pengirim || actorKodeCabang || '',
      merk: row?.merk || '-',
      kapasitas: row?.kapasitas || '-',
      kategori: row?.kategori || '-',
      status: row?.status || '-',
      roda: Number(row?.roda || profil?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || profil?.cadangan || selected?.cadangan || 0),
      tahun_pembuatan: row?.tahun_pembuatan || '',
      kir: row?.kir || '',
      odo_awal: Number(row?.odo_awal || 0),
      catatan_mt: row?.catatan_mt || '',
      tanggal: row?.tanggal || '',
      user: row?.user || actorNama || '',
      lampiran: Array.isArray(row?.lampiran) ? row.lampiran : [],
      lampiran_mt_event: row?.lampiran_mt_event || ''
    };
  };
  useEffect(() => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) {
      setSelectedMtDetail(null);
      return;
    }
    let alive = true;
    const loadMtDetailById = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_MT_PROFIL_LOAD,
          reason: `refresh mt profil penonaktifan ${idMt}`,
        });
        const { data: rows } = await api.get(`${backendPort}/api/main/mt_profil`, {
          params: { id_mt: idMt },
          requestGroup: REQ_GROUP_WO_MT_PROFIL_LOAD,
          timeout: 120000,
        });
        if (!alive) return;
        const row = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
        setSelectedMtDetail(row);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat detail MT penonaktifan:', err);
        setSelectedMtDetail(null);
      }
    };
    loadMtDetailById();
    return () => {
      alive = false;
    };
  }, [dataWO?.mt]);
  const openMtDetailModal = () => {
    const detail = buildMtDetailData();
    if (!detail) return;
    setMtDetailData(detail);
    setShowMtDetailModal(true);
  };
  const isDataKunciTerisi = Boolean(
    dataWO?.mt &&
    hasSelectedAksi &&
    String(dataWO?.nomor || '').trim() !== '' &&
    String(dataWO?.tanggal || '').trim() !== ''
  );

  useEffect(() => {
    setDataWO((prev) => ({
      ...prev,
      jenis: action.value,
      pengirim: isPusatUser ? '' : (actorKodeCabang || 'invalid'),
      mt: '',
      nopol: '',
      aksi_penonaktifan: '',
      catatan_mt: '',
      check_validasi_mt: false,
      nama_pemeriksa_mt: actorNama || '',
    }));
  }, []);
  useEffect(() => {
    if (!hasSelectedMt) return;
    loadLastCheckSummary(dataWO?.mt, false);
  }, [hasSelectedMt, dataWO?.mt]);
  useEffect(() => {
    if (!dataWO?.mt || String(dataWO?.pengirim || '').trim()) return;
    const mtRow = (Array.isArray(opsiMT) ? opsiMT : [])
      .find((x) => String(x?.id_mt || '').trim() === String(dataWO?.mt || '').trim());
    const kodeCabang = String(mtRow?.kode_cabang || '').trim();
    if (!kodeCabang) return;
    setDataWO((prev) => {
      if (String(prev?.mt || '').trim() !== String(dataWO?.mt || '').trim()) return prev;
      if (String(prev?.pengirim || '').trim()) return prev;
      return { ...prev, pengirim: kodeCabang };
    });
  }, [dataWO?.mt, dataWO?.pengirim, opsiMT, setDataWO]);
  useEffect(() => {
    if (hasSelectedMt) return;
    setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
    setTodayCheckStatus({ odo: false, td: false });
    setShowOdoUpdateModal(false);
    setShowTdUpdateModal(false);
    setShowMtDetailModal(false);
    setMtDetailData(null);
  }, [hasSelectedMt]);
  useEffect(() => {
    if (!hasSelectedMt) return;
    setDataWO((prev) => {
      const current = String(prev?.aksi_penonaktifan || '').trim();
      if (!current) return prev;
      if (opsiJenisAksi.some((x) => String(x).trim() === current)) return prev;
      return { ...prev, aksi_penonaktifan: '' };
    });
  }, [hasSelectedMt, opsiJenisAksi, setDataWO]);

  if (activeMenu !== action.value) return null;

  const handleSubmit = async () => {
    if (!isDataKunciTerisi) {
      showNotif('error', 'Lengkapi data utama terlebih dahulu.');
      return;
    }
    if (!canShowDetailSection) {
      showNotif('error', 'Pilih MT terlebih dahulu dan pastikan nomor transaksi sudah terisi.');
      return;
    }
    if (!hasSelectedAksi) {
      showNotif('error', 'Pilih jenis aksi terlebih dahulu.');
      return;
    }
    if (!canSubmit) {
      showNotif('error', 'Submit belum bisa dilanjutkan karena Last Check ODO dan TD belum update per hari ini.');
      return;
    }
    const invalidIndexes = collectInvalidCaptionIndexes();
    if (!attachments.length) {
      setIsLampiranInvalid(true);
      showNotif('error', 'Upload dokumen wajib diisi.');
      return;
    }
    if (invalidIndexes.length > 0) {
      setIsLampiranInvalid(false);
      setInvalidCaptionIndexes(invalidIndexes);
      showNotif('error', 'Caption dokumen wajib diisi untuk semua lampiran.');
      return;
    }
    const aksiRaw = String(dataWO?.aksi_penonaktifan || '').trim().toLowerCase();
    const aksiKey = (aksiRaw === 'aktif' || aksiRaw === 'aktifasi' || aksiRaw === 'aktivasi')
      ? 'aktif'
      : (aksiRaw === 'non aktif' || aksiRaw === 'nonaktif' || aksiRaw === 'non_aktif')
        ? 'non_aktif'
        : aksiRaw;
    if (!isPusatUser) {
      if (!actorKodeCabang || actorKodeCabang === 'invalid') {
        showNotif('error', 'Kode cabang user tidak valid.');
        return;
      }
      if (aksiKey === 'hapus') {
        showNotif('error', 'User cabang tidak boleh melakukan Hapus MT.');
        return;
      }
      if (!['aktif', 'non_aktif'].includes(aksiKey)) {
        showNotif('error', 'User cabang hanya boleh melakukan Aktivasi atau Non Aktif MT.');
        return;
      }
      const kodeCabangMt = String(dataWO?.pengirim || '').trim();
      if (kodeCabangMt && kodeCabangMt !== actorKodeCabang) {
        showNotif('error', 'User cabang hanya boleh mengubah status MT cabangnya sendiri.');
        return;
      }
    }
    setIsLampiranInvalid(false);
    setInvalidCaptionIndexes([]);
    try {
      setIsSubmitting(true);
      const submitKodeCabang = isPusatUser
        ? String(dataWO?.pengirim || actorKodeCabang || '').trim()
        : actorKodeCabang;
      const formData = new FormData();
      formData.append('nomorWO', String(dataWO?.nomor || '').trim());
      formData.append('id_mt', String(dataWO?.mt || '').trim());
      formData.append('tanggal', String(dataWO?.tanggal || '').trim());
      formData.append('kode_cabang', submitKodeCabang);
      formData.append('aksi_penonaktifan', String(dataWO?.aksi_penonaktifan || '').trim());
      formData.append('catatan', String(dataWO?.catatan_mt ?? ''));
      formData.append('user', String(actorNama || dataWO?.user || '').trim());
      attachments.forEach((item) => {
        if (item?.file) formData.append('files', item.file);
        formData.append('captions', item?.caption || '');
      });
      const existingLampiran = attachments
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || '',
          file: item?.db_file || item?.file || '',
          path: item?.path || '',
          type: item?.type || '',
          size: Number(item?.size || 0),
          caption: item?.caption || '',
          uploaded_at: item?.uploaded_at || null,
      }));
      formData.append('existing_lampiran', JSON.stringify(existingLampiran));

      api.cancelPendingRequests({
        group: REQ_GROUP_WO_UBAH_STATUS_SUBMIT,
        reason: 'submit ubah status mt terbaru',
      });
      await api.post(`${backendPort}/api/main/submit_ubah_status_mt`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        requestGroup: REQ_GROUP_WO_UBAH_STATUS_SUBMIT,
        timeout: 120000,
      });
      if (typeof manualResyncGlobalOpsi === 'function') {
        await manualResyncGlobalOpsi({ force: true, requestGroup: 'wo-ubah-status-sync' });
      }
      if (typeof loadNomorWO === 'function') {
        loadNomorWO();
      }
      setAttachments([]);
      setInvalidCaptionIndexes([]);
      setIsLampiranInvalid(false);
      showNotif('success', 'Ubah status MT berhasil disimpan.');
      setActiveMenu('');
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif('error', err?.response?.data?.message || 'Gagal submit ubah status MT.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmitWithConfirm = () => {
    const aksi = String(dataWO?.aksi_penonaktifan || '').trim().toLowerCase();
    if (aksi !== 'hapus') {
      handleSubmit();
      return;
    }
    showConfirm({
      title: 'Konfirmasi',
      message: 'Anda akan menghapus MT dengan nopol dari system. Lanjutkan?',
      onConfirm: () => {
        handleSubmit();
      },
    });
  };

  return (
    <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
        <div>
          <p className="page16-panel-label mb-1">Detail Aktivitas</p>
          <h4 className="page16-panel-title mb-1">{action.title}</h4>
          <p className="text-muted small mb-0">{action.description}</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      <div className="row g-3">
        <div className="col-12 col-md-3">
          <label className="form-label">No. Pol. MT</label>
          <input
            type="text"
            className={`form-control ${invalidMtPenonaktifan ? 'field-required-invalid' : ''}`}
            readOnly
            style={{ cursor: 'pointer' }}
            placeholder="Pilih NoPol MT"
            value={dataWO?.nopol || ''}
            onClick={() => setShowCariMtModal(true)}
          />
        </div>
        <div className="col-12 col-md-3">
          <label className="form-label">Jenis Aksi</label>
          <select
            className={`form-select ${invalidAksiPenonaktifan ? 'field-required-invalid' : ''}`}
            value={dataWO?.aksi_penonaktifan || ''}
            onChange={(e) => setDataWO((prev) => ({ ...prev, aksi_penonaktifan: e.target.value }))}
          >
            <option value="">Pilih Aksi</option>
            {opsiJenisAksi.map((item) => (
              <option key={`ubah-status-aksi-${item}`} value={item}>{item}</option>
            ))}
          </select>
        </div>
        <div className="col-12 col-md-3">
          <label className="form-label">No. Transaksi</label>
          <input type="text" className="form-control" readOnly value={toNomorPreviewDisplay(dataWO?.nomor || '')} />
        </div>
        <div className="col-12 col-md-3">
          <label className="form-label">Tanggal Input</label>
          <input
            type="date"
            className="form-control"
            value={dataWO?.tanggal || ''}
            readOnly
            onChange={(e) => setDataWO((prev) => ({ ...prev, tanggal: e.target.value }))}
          />
        </div>
        {canShowDetailSection && (
          <>
            <div className="col-12">
              <div className="card page16-soft-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>{`Lihat Detail MT : ${dataWO?.nopol ?? ''}`}</span>
                    <button
                      className="btn btn-outline-primary"
                      disabled={!summary.td.total}
                      onClick={openMtDetailModal}
                    >
                      Lihat
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="card page16-info-card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="page16-info-title">LAST Check</span>
                    <span className="badge text-bg-light">{dataWO?.nopol || 'Belum pilih MT'}</span>
                  </div>
                  <div className="row g-2">
                    <div className="col-12 col-md-6">
                      <div className="page16-info-item">
                        <small>ODO / KM TEMPUH MT</small>
                        <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowOdoUpdateModal(true)}>
                          {loadingSummary ? 'Memuat...' : summary.odo.value}
                        </button>
                        <span className={todayCheckStatus.odo ? 'text-success' : 'text-danger'}>
                          Check: {formatDateLocal(todayCheckStatus.odo ? todayISO : summary.odo.date)} ({dayDiffLabel(todayCheckStatus.odo ? todayISO : summary.odo.date)})
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="page16-info-item">
                        <small>TD BAN</small>
                        <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowTdUpdateModal(true)}>
                          {loadingSummary ? 'Memuat...' : `${summary.td.terpasang} + ${summary.td.cadangan} ban`}
                        </button>
                        <span className={todayCheckStatus.td ? 'text-success' : 'text-danger'}>
                          Check: {formatDateLocal(todayCheckStatus.td ? todayISO : summary.td.oldestDate)} ({dayDiffLabel(todayCheckStatus.td ? todayISO : summary.td.oldestDate)})
                        </span>
                      </div>
                    </div>
                  </div>
                  {(!todayCheckStatus.odo || !todayCheckStatus.td) && (
                    <div className="mt-2">
                      <small className="text-danger fst-italic fw-light">
                        Anda belum dapat melanjutkan proses ubah status karena data ODO dan TD ban belum update per hari ini.
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="card page16-soft-card h-100">
                <div className="card-body">
                  <label className="form-label">Catatan Ubah Status MT</label>
                  <textarea
                    rows={4}
                    className="form-control"
                    placeholder="Masukkan catatan ubah status MT..."
                    value={dataWO?.catatan_mt ?? ''}
                    onChange={(e) => setDataWO((prev) => ({ ...prev, catatan_mt: e.target.value }))}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className={`card page16-soft-card h-100 ${isLampiranInvalid ? 'field-required-invalid' : ''}`}>
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <span>Upload Dokumen MT</span>
                  </div>
                  <PageKonten9_Pict
                    attachments={attachments}
                    setAttachments={(updater) => {
                      setAttachments((prev) => {
                        const next = typeof updater === 'function' ? updater(prev) : updater;
                        if (Array.isArray(next) && next.length > 0) setIsLampiranInvalid(false);
                        return next;
                      });
                    }}
                    bisaInput
                    invalidCaptionIndexes={invalidCaptionIndexes}
                    onCaptionChange={() => {
                      if (!invalidCaptionIndexes.length) return;
                      setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="card page16-verify-card page16-soft-card">
                <div className="card-body">
                  <div className="row g-2 align-items-center">
                    <div className="col-12 col-md-8">
                      <span className="fw-semibold">Petugas Input</span>
                    </div>
                    <div className="col-12 col-md-4 ms-md-auto">
                      <input
                        type="text"
                        className="form-control"
                        value={actorNama || '-'}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {canShowDetailSection && (
        <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
            Batal
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmitWithConfirm} disabled={!canSubmit || isSubmitting}>
            {isSubmitting ? 'Memproses...' : action.submitLabel}
          </button>
        </div>
      )}

      <ModalCariMT
        open={showCariMtModal}
        onClose={() => setShowCariMtModal(false)}
        showNotif={showNotif}
        allowNonAktifSelection={true}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || '').trim();
          if (!idMt) return;
          const mtRef = (Array.isArray(opsiMT) ? opsiMT : [])
            .find((x) => String(x?.id_mt || '').trim() === idMt);
          const kodeCabangMt = String(mt?.kode_cabang || mtRef?.kode_cabang || '').trim();
          if (!isPusatUser && kodeCabangMt && kodeCabangMt !== actorKodeCabang) {
            showNotif('error', 'User cabang hanya boleh memilih MT cabangnya sendiri.');
            return;
          }
          setDataWO((prev) => ({
            ...prev,
            pengirim: isPusatUser ? kodeCabangMt : actorKodeCabang,
            mt: idMt,
            nopol: mt?.nopol || '',
          }));
          setShowCariMtModal(false);
        }}
        title="Pilih No. Pol MT"
        globalOpsi={globalOpsi}
        kodeCabang={isPusatUser ? "" : actorKodeCabang}
        treatPusatAsAll={isPusatUser}
      />

      {showOdoUpdateModal && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: 'min(1100px, 96vw)' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="odo"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowOdoUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showTdUpdateModal && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '97vw' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="td"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowTdUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showMtDetailModal && mtDetailData && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
        <div className="page16-modal-card" style={{ width: '90vw', maxHeight: '92vh', overflowY: 'auto' }}>
            
            <PageKonten9_Show
              globalOpsi={globalOpsi}
              editData={mtDetailData}
              setShowDetail={setShowMtDetailModal}
              setShowMaster={() => {}}
            />
            
        </div>
        </div>
      )}
    </div>
  );
}
function PanelMutasiMT({ action, activeMenu, setActiveMenu, dataWO, setDataWO, opsiMT, opsiCabang, authIdentity = {}, loadNomorWO, mtProfilMap, mtDetailMap, globalOpsi, manualResyncGlobalOpsi, resendToken = 0 }) {
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const actorNama = String(authIdentity?.nama || '').trim();
  const isPusat = actorKodeCabang === 'C-1';
  const namaCabangUser = (
    (Array.isArray(opsiCabang) ? opsiCabang : []).find((x) => String(x?.kode_cabang || '').trim() === actorKodeCabang)?.nama_cabang
    || actorKodeCabang
  );
  const {showNotif} = useNotification();
  const [bisaSubmit, setBisaSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [invalidCaptionIndexes, setInvalidCaptionIndexes] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [summary, setSummary] = useState({
    odo: { value: '-', date: null },
    td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
    banDetails: {},
    banPositionMap: {}
  });
  const [showBanPopup, setShowBanPopup] = useState(false);
  const [showPilihBanPopup, setShowPilihBanPopup] = useState(false);
  const [showOdoUpdateModal, setShowOdoUpdateModal] = useState(false);
  const [showTdUpdateModal, setShowTdUpdateModal] = useState(false);
  const [selectedPosisi, setSelectedPosisi] = useState('');
  const [todayCheckStatus, setTodayCheckStatus] = useState({ odo: false, td: false });
  const [pilihBanPair, setPilihBanPair] = useState({ ban1Pos: '', ban2Pos: '' });
  const [pilihBanChecked, setPilihBanChecked] = useState({ ban1: false, ban2: false });
  const [pilihBanFinalPair, setPilihBanFinalPair] = useState({ ban1Pos: '', ban2Pos: '' });
  const [banEventMap, setBanEventMap] = useState({});
  const [loadingPilihBanMeta, setLoadingPilihBanMeta] = useState(false);
  const [showMtDetailModal, setShowMtDetailModal] = useState(false);
  const [mtDetailData, setMtDetailData] = useState(null);
  const [showCariMtMutasiModal, setShowCariMtMutasiModal] = useState(false);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);

  const todayISO = formatYYYYMMDD(new Date());
  const labelAsal = 'Mutasi Keluar dari';
  const labelTujuan = 'Mutasi Masuk Ke';
  const warningCheck = 'Anda belum dapat melanjutkan proses mutasi karena data ODO dan TD ban belum update per hari ini.';
  const labelDetailMt = `Lihat Detail MT : ${dataWO?.nopol ?? ''}`;
  const placeholderCatatan = 'Masukkan catatan terbaru terkait kondisi MT, hasil pengecekan, atau hal penting lainnya...';
  const labelUpload = 'Upload Dokumen Mutasi MT';
  const labelDetailPopup = 'Histori ban diambil dari ban_event.';
  const formatDateLocal = formatDateLocalLabel;
  const dayDiffLabel = dayDiffLabelFromKey;
  const getSelectedMT = () => opsiMT.find((x) => x.id_mt === dataWO?.mt) || null;
  const buildMtDetailData = () => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) return null;
    const row = selectedMtDetail || mtDetailMap?.[idMt] || {};
    const selected = getSelectedMT() || {};
    const profil = {
      roda: Number(row?.roda || mtProfilMap?.[idMt]?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || mtProfilMap?.[idMt]?.cadangan || selected?.cadangan || 0),
    };
    return {
      id_mt: row?.id_mt || selected?.id_mt || idMt,
      nopol: row?.nopol || selected?.nopol || '-',
      kode_cabang: row?.kode_cabang || selected?.kode_cabang || dataWO?.pengirim || actorKodeCabang || '',
      merk: row?.merk || '-',
      kapasitas: row?.kapasitas || '-',
      kategori: row?.kategori || '-',
      status: row?.status || '-',
      roda: Number(row?.roda || profil?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || profil?.cadangan || selected?.cadangan || 0),
      tahun_pembuatan: row?.tahun_pembuatan || '',
      kir: row?.kir || '',
      odo_awal: Number(row?.odo_awal || 0),
      catatan_mt: row?.catatan_mt || '',
      tanggal: row?.tanggal || '',
      user: row?.user || actorNama || '',
      lampiran: Array.isArray(row?.lampiran) ? row.lampiran : [],
      lampiran_mt_event: row?.lampiran_mt_event || ''
    };
  };
  const openMtDetailModal = () => {
    const detail = buildMtDetailData();
    if (!detail) return;
    setMtDetailData(detail);
    setShowMtDetailModal(true);
  };
  const selectedMtProfil = selectedMtDetail
    ? {
        roda: Number(selectedMtDetail?.roda || 0),
        cadangan: Number(selectedMtDetail?.cadangan || 0),
      }
    : (mtProfilMap?.[dataWO?.mt] || null);
  const isDataKunciTerisi = Boolean(dataWO?.pengirim && dataWO?.penerima && dataWO?.mt);
  const selectedDetail = summary.banDetails?.[selectedPosisi] || null;
  const selectedDetailHistori = banEventMap?.[Number(selectedDetail?.idBan || 0)] || [];
  const resolveBanCard = (posisi) => {
    if (!posisi) return null;
    const base = summary?.banDetails?.[posisi] || null;
    if (!base) return null;
    const histori = banEventMap?.[base.idBan] || [];
    const latestEvent = histori[0] || null;
    return {
      ...base,
      latestStatus: latestEvent?.status || base?.statusProfil || '-',
      latestCatatan: latestEvent?.catatan_ban || '-',
      histori,
    };
  };
  const ban1Card = resolveBanCard(pilihBanPair.ban1Pos);
  const ban2Card = resolveBanCard(pilihBanPair.ban2Pos);
  const pilihBanSiap = Boolean(pilihBanChecked.ban1 && pilihBanChecked.ban2);
  const pilihBanFinalBan1 = summary?.banDetails?.[pilihBanFinalPair.ban1Pos] || null;
  const pilihBanFinalBan2 = summary?.banDetails?.[pilihBanFinalPair.ban2Pos] || null;
  const showPilihBanFinalBox = Boolean(pilihBanFinalBan1 || pilihBanFinalBan2);
  const checkHarianSiap = Boolean(todayCheckStatus.odo && todayCheckStatus.td);
  const isSameCabangMutasi = String(dataWO?.pengirim || '').trim() !== ''
    && String(dataWO?.pengirim || '').trim() === String(dataWO?.penerima || '').trim();
  const dataFinalLengkap = isDataKunciTerisi
    && checkHarianSiap
    && !isSameCabangMutasi;
  const invalidPengirimMutasi = !String(dataWO?.pengirim || '').trim();
  const invalidPenerimaMutasi = !String(dataWO?.penerima || '').trim();
  const invalidMtMutasi = !String(dataWO?.mt || '').trim();
  const collectInvalidCaptionIndexes = () => (
    (Array.isArray(attachments) ? attachments : [])
      .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  
  useEffect(()=>{
    const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
    setDataWO(prev=>({
      ...prev,
      jenis : action.value,
      pengirim : defaultPengirim,
      penerima : '',
      mt: '',
      nopol: '',
      catatan_mt: '',
      check_validasi_mt: false,
      nama_pemeriksa_mt: actorNama ?? ''
    }));
  },[]);

  useEffect(() => {
    setBisaSubmit(dataFinalLengkap);
  }, [dataFinalLengkap]);

  useEffect(() => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) {
      setSelectedMtDetail(null);
      return;
    }
    let alive = true;
    const loadMtDetailById = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_MT_PROFIL_LOAD,
          reason: `refresh mt profil mutasi ${idMt}`,
        });
        const { data: rows } = await api.get(`${backendPort}/api/main/mt_profil`, {
          params: { id_mt: idMt },
          requestGroup: REQ_GROUP_WO_MT_PROFIL_LOAD,
          timeout: 120000,
        });
        if (!alive) return;
        const row = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
        setSelectedMtDetail(row);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat detail MT mutasi:', err);
        setSelectedMtDetail(null);
      }
    };
    loadMtDetailById();
    return () => {
      alive = false;
    };
  }, [dataWO?.mt]);
  
  const loadLastCheckSummary = async (idMt, force = false) => {
    if (!idMt) {
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
      setSelectedPosisi('');
      return;
    }

    setLoadingSummary(true);
    setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
    setTodayCheckStatus({ odo: false, td: false });
    try {
      const selectedMT = getSelectedMT();
      const result = await loadGlobalOdoTdCheckByMt(idMt, selectedMT, force);
      setSummary(result.summary);
      setTodayCheckStatus(result.todayCheckStatus);
      setSelectedPosisi(Object.keys(result.summary?.banDetails || {})[0] || '');
    } catch (error) {
      if (api.isCanceledError(error)) return;
      console.error(error);
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
      setSelectedPosisi('');
    } finally {
      setLoadingSummary(false);
    }
  };

  useEffect(() => {
    if (!isDataKunciTerisi) return;
    loadLastCheckSummary(dataWO?.mt, Boolean(resendToken));
  }, [isDataKunciTerisi, dataWO?.mt, resendToken]);

  useEffect(() => {
    if (isDataKunciTerisi) return;
    setSummary({
      odo: { value: '-', date: null },
      td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
      banDetails: {},
      banPositionMap: {}
    });
    setTodayCheckStatus({ odo: false, td: false });
    setSelectedPosisi('');
    setShowBanPopup(false);
    setShowPilihBanPopup(false);
    setShowOdoUpdateModal(false);
    setShowTdUpdateModal(false);
    setPilihBanFinalPair({ ban1Pos: '', ban2Pos: '' });
    setPilihBanPair({ ban1Pos: '', ban2Pos: '' });
    setPilihBanChecked({ ban1: false, ban2: false });
  }, [isDataKunciTerisi]);

  useEffect(() => {
    if (!showPilihBanPopup) return;
    const posisiAvailable = Object.keys(summary?.banDetails || {})
      .filter((pos) => Boolean(summary?.banDetails?.[pos]?.idBan))
      .sort((a, b) => a.localeCompare(b));
    const initialBan1 = pilihBanFinalPair.ban1Pos || posisiAvailable[0] || '';
    const initialBan2 = pilihBanFinalPair.ban2Pos || posisiAvailable[1] || posisiAvailable[0] || '';
    setPilihBanPair({ ban1Pos: initialBan1, ban2Pos: initialBan2 });
    setPilihBanChecked({
      ban1: Boolean(pilihBanFinalPair.ban1Pos),
      ban2: Boolean(pilihBanFinalPair.ban2Pos),
    });
  }, [showPilihBanPopup, summary?.banDetails, pilihBanFinalPair.ban1Pos, pilihBanFinalPair.ban2Pos]);

  useEffect(() => {
    const loadHistoriBan = async () => {
      if (!showPilihBanPopup && !showBanPopup) return;
      const ids = [...new Set(
        Object.values(summary?.banDetails || {})
          .map((x) => Number(x?.idBan || 0))
          .filter((x) => Number.isFinite(x) && x > 0)
      )];
      if (!ids.length) {
        setBanEventMap({});
        return;
      }
      setLoadingPilihBanMeta(true);
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_MUTASI_HISTORY_LOAD,
          reason: 'refresh histori ban mutasi',
        });
        const { data } = await api.post(`${backendPort}/api/main/load_ban_event_history_by_ban`, { kodeBan: ids }, {
          requestGroup: REQ_GROUP_WO_MUTASI_HISTORY_LOAD,
          timeout: 30000,
        });
        const rows = Array.isArray(data) ? data : [];
        const mapped = {};
        rows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan) return;
          if (!mapped[idBan]) mapped[idBan] = [];
          mapped[idBan].push(row);
        });
        setBanEventMap(mapped);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error(err);
        setBanEventMap({});
      } finally {
        setLoadingPilihBanMeta(false);
      }
    };
    loadHistoriBan();
  }, [showPilihBanPopup, showBanPopup, summary?.banDetails, resendToken]);

  const handleOdoTdSaved = () => {
    if (!dataWO?.mt) return;
    loadLastCheckSummary(dataWO.mt, true);
  };
  const handleSubmit = async() => {
    try{
      if (!bisaSubmit) {
        showNotif("error", "Lengkapi data mutasi dan update ODO-TD semua ban terlebih dahulu.");
        return;
      }
      if (isSameCabangMutasi) {
        showNotif("error", "Cabang Mutasi Keluar dan Mutasi Masuk tidak boleh sama.");
        return;
      }
      if (!String(dataWO?.nomor || '').trim()) {
        showNotif("error","Nomor WO belum tersedia. Klik Refresh lalu coba lagi.");
        return;
      }
      const invalidIndexes = collectInvalidCaptionIndexes();
      if (invalidIndexes.length > 0) {
        setInvalidCaptionIndexes(invalidIndexes);
        showNotif('error', 'Caption dokumen wajib diisi untuk semua lampiran.');
        return;
      }
      setInvalidCaptionIndexes([]);
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('nomorWO', String(dataWO?.nomor || '').trim());
      attachments.forEach((item) => { //untuk upload file
        if (item?.file) formData.append('files', item.file);
        formData.append('captions', item?.caption || '');
      });
      formData.append('id_mt', dataWO.mt);
      formData.append('tanggal', dataWO.tanggal);
      formData.append('kode_cabang_pengirim', dataWO.pengirim);
      formData.append('kode_cabang_penerima', dataWO.penerima);
      formData.append('odo', 0); //angka sementara
      formData.append('kmtotal', 0); //angka sementara
      //formData.append('daftar_ban', {}); //ambil dari mt_event terakhir key yang sama: kode_cabang, id_mt
      formData.append('catatan_mt', dataWO.catatan_mt);
      const existingLampiran = attachments
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || '',
          file: item?.db_file || item?.file || '',
          path: item?.path || '',
          type: item?.type || '',
          size: Number(item?.size || 0),
          caption: item?.caption || '',
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append('existing_lampiran', JSON.stringify(existingLampiran));
      const reff = {'pengirim' : dataWO.pengirim, 'penerima': dataWO.penerima };
      formData.append('reff', JSON.stringify(reff));
      formData.append('user', dataWO.user);
      api.cancelPendingRequests({
        group: REQ_GROUP_WO_MUTASI_SUBMIT,
        reason: 'submit mutasi terbaru',
      });
      await api.post(`${backendPort}/api/main/submit_mutasi`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        requestGroup: REQ_GROUP_WO_MUTASI_SUBMIT,
        timeout: 120000,
      });
      if (typeof manualResyncGlobalOpsi === 'function') {
        await manualResyncGlobalOpsi({ force: true, requestGroup: 'wo-mutasi-sync' });
      }
      
      showNotif('success', 'Data berhasil disimpan');
      setInvalidCaptionIndexes([]);
      loadNomorWO();
      setActiveMenu('');
      
    }catch(e){
      if (api.isCanceledError(e)) return;
      console.log(e);
      showNotif("error", "Gagal submit data");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (activeMenu !== action.value) return null;

  return (
    <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
        <div>
          <p className="page16-panel-label mb-1">Detail Aktivitas</p>
          <h4 className="page16-panel-title mb-1">{action.title}</h4>
          <p className="text-muted small mb-0">{action.description}</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>
      <div className="row g-3 mb-3">
        <div className="col-12 col-md-4">
          <label className="form-label">{labelAsal}</label>
          <select
            type="text"
            className={`form-select ${(invalidPengirimMutasi || isSameCabangMutasi) ? 'field-required-invalid' : ''}`}
            value={dataWO?.pengirim ?? ''}
            onChange={(e) => setDataWO(prev => ({
              ...prev,
              pengirim: e.target.value,
              mt: '',
              nopol: ''
            }))}
          >
            {!isPusat && <option key ={""} value ={actorKodeCabang}>{namaCabangUser || actorKodeCabang}</option>}
            {isPusat && <option key ={""} value ={""}>-Pilih Cabang-</option>}
            {isPusat && opsiCabang.map((x)=><option key ={x.kode_cabang} value ={x.kode_cabang}>{x.nama_cabang}</option>)}
          </select>
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">{labelTujuan}</label>
          <select type="text" className={`form-select ${(invalidPenerimaMutasi || isSameCabangMutasi) ? 'field-required-invalid' : ''}`} value={dataWO?.penerima ?? ''} onChange={(e) => setDataWO(prev=>({...prev, penerima : e.target.value}))}>
            <option key ={""} value ={""}>-Pilih Cabang-</option>
            {opsiCabang.map((x)=><option key ={x.kode_cabang} value ={x.kode_cabang}>{x.nama_cabang}</option>)}
          </select>
        </div>
        <div className="col-12 col-md-4" />
      </div>
      {isSameCabangMutasi && (
        <div className="row mb-2">
          <div className="col-12">
            <small className="text-danger fw-semibold">Cabang Mutasi Keluar dan Mutasi Masuk tidak boleh sama.</small>
          </div>
        </div>
      )}

      <div className="row g-3 mb-3">
        <div className="col-12 col-md-4">
          <label className="form-label">No. Pol. MT</label>
          <input
            type="text"
            className={`form-control ${invalidMtMutasi ? 'field-required-invalid' : ''}`}
            readOnly
            style={{ cursor: "pointer" }}
            placeholder="Pilih NoPol MT"
            value={dataWO?.nopol || ""}
            onClick={() => {
              if (!dataWO?.pengirim) return;
              setShowCariMtMutasiModal(true);
            }}
          />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Nomor Transaksi</label>
          <input type="text" className="form-control" readOnly value={toNomorPreviewDisplay(dataWO?.nomor || '')} />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Tanggal Input</label>
          <input
            type="date"
            className="form-control"
            value={dataWO?.tanggal || ''}
            readOnly
          />
        </div>
      </div>

      {isDataKunciTerisi && (
      <div className="row g-3 mt-1">
        <div className="col-12">
          <div className="card page16-info-card">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="page16-info-title">LAST Check</span>
                <span className="badge text-bg-light">{dataWO?.nopol || 'Belum pilih MT'}</span>
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-6">
                  <div className="page16-info-item">
                    <small>ODO / KM TEMPUH MT</small>
                    <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowOdoUpdateModal(true)}>
                      {loadingSummary ? 'Memuat...' : summary.odo.value}
                    </button>
                    <span className={todayCheckStatus.odo ? 'text-success' : 'text-danger'}>
                      Check: {formatDateLocal(todayCheckStatus.odo ? todayISO : summary.odo.date)} ({dayDiffLabel(todayCheckStatus.odo ? todayISO : summary.odo.date)})
                    </span>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="page16-info-item">
                    <small>TD BAN</small>
                    <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowTdUpdateModal(true)}>
                      {loadingSummary ? 'Memuat...' : `${summary.td.terpasang} + ${summary.td.cadangan} ban`}
                    </button>
                    <span className={todayCheckStatus.td ? 'text-success' : 'text-danger'}>
                      Check: {formatDateLocal(todayCheckStatus.td ? todayISO : summary.td.oldestDate)} ({dayDiffLabel(todayCheckStatus.td ? todayISO : summary.td.oldestDate)})
                    </span>
                  </div>
                </div>
              </div>
              {(!todayCheckStatus.odo || !todayCheckStatus.td) && (
                <div className="mt-2">
                  <small className="text-danger fst-italic fw-light">
                    {warningCheck}
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card page16-soft-card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                <span>{labelDetailMt}</span>
                <button 
                  className='btn btn-outline-primary'
                  disabled={!summary.td.total}
                  onClick={openMtDetailModal}
                >
                  Lihat
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="card page16-soft-card h-100">
            <div className="card-body">
              <label className="form-label">Catatan Terbaru MT</label>
              <textarea
                rows={3}
                className="form-control"
                placeholder={placeholderCatatan}
                value={dataWO?.catatan_mt ?? ''}
                onChange={(e) => setDataWO(prev => ({ ...prev, catatan_mt: e.target.value }))}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="card page16-soft-card">
            <div className='card-body'>
              <div className='d-flex justify-content-center'>
                <span>{labelUpload}</span>
              </div>
              <PageKonten9_Pict
                attachments={attachments}
                setAttachments={setAttachments}
                bisaInput={true}
                invalidCaptionIndexes={invalidCaptionIndexes}
                onCaptionChange={() => {
                  if (!invalidCaptionIndexes.length) return;
                  setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card page16-verify-card page16-soft-card">
            <div className="card-body">
              <div className="row g-2 align-items-center">
                <div className="col-12 col-md-8">
                  <span className="fw-semibold">Petugas Input</span>
                </div>
                <div className="col-12 col-md-4 ms-md-auto">
                  <input
                    type="text"
                    className="form-control"
                    value={actorNama || '-'}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}

      {isDataKunciTerisi && (
        <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
            Batal
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={!bisaSubmit || isSubmitting}>
            {isSubmitting ? 'Memproses...' : action.submitLabel}
          </button>
        </div>
      )}

      <ModalCariMT
        open={showCariMtMutasiModal}
        onClose={() => setShowCariMtMutasiModal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || '').trim();
          const nopol = String(mt?.nopol || '').trim();
          setDataWO((prev) => ({ ...prev, mt: idMt, nopol }));
        }}
        title="Pilih No. Pol MT"
        globalOpsi={globalOpsi}
        kodeCabang={dataWO?.pengirim || actorKodeCabang || ""}
        treatPusatAsAll={false}
      />

      {showOdoUpdateModal && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: 'min(1100px, 96vw)' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="odo"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowOdoUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showTdUpdateModal && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '97vw' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="td"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowTdUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showMtDetailModal && mtDetailData && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '90vw', maxHeight: '92vh', overflowY: 'auto' }}>
            <PageKonten9_Show
              globalOpsi={globalOpsi}
              editData={mtDetailData}
              setShowDetail={setShowMtDetailModal}
              setShowMaster={() => {}}
            />
          </div>
        </div>
      )}

      {showBanPopup && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card">
            <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
              <div>
                <h5 className="mb-1">Detail Ban MT - {dataWO?.nopol || '-'}</h5>
                <small className="text-muted">{labelDetailPopup}</small>
              </div>
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowBanPopup(false)}>
                Tutup
              </button>
            </div>

            <div className="row g-3 justify-content-center">
              <div className="col-12 col-lg-5">
                <div className="page16-popup-formasi">
                  <FormasiBan
                    formasi={Number(selectedMtProfil?.roda || getSelectedMT()?.roda || 16)}
                    cadangan={Number(selectedMtProfil?.cadangan || getSelectedMT()?.cadangan || 3)}
                    onClick={(pos) => setSelectedPosisi(pos)}
                    daftarKodeBan={summary.banPositionMap}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="page16-popup-detail">
                  <h6 className="mb-3">{selectedDetail?.posisi || '-'} | Detail Ban</h6>
                  <div className="row g-2 small">
                    <div className="col-6"><strong>Posisi:</strong> {selectedDetail?.posisi || '-'}</div>
                    <div className="col-6"><strong>No Seri:</strong> {selectedDetail?.seri || '-'}</div>
                    <div className="col-6"><strong>TD:</strong> {selectedDetail?.td || '-'}</div>
                    <div className="col-6"><strong>KM Tempuh:</strong> {selectedDetail?.kmTempuh || 0}</div>
                    <div className="col-6"><strong>Wear Rate:</strong> {selectedDetail?.wearRate || '-'}</div>
                    <div className="col-6"><strong>Tgl Initial:</strong> {formatDateLocal(selectedDetail?.tanggalInitial)}</div>
                    <div className="col-6"><strong>Last cek ODO:</strong> {formatDateLocal(selectedDetail?.lastOdoDate)}</div>
                    <div className="col-6"><strong>Last cek TD:</strong> {formatDateLocal(selectedDetail?.lastTdDate)}</div>
                  </div>

                  <div className="mt-3">
                    <strong className="small d-block mb-1">Histori Ban</strong>
                    <div className="page16-rotasi-histori">
                      {selectedDetailHistori.slice(0, 12).map((item, idx) => (
                        <div key={`mutasi-detail-${idx}`} className="page16-rotasi-histori-item">
                          <small className="text-muted">{formatDateLocal(item?.tanggal)} | {item?.event || '-'}</small>
                          <div className="small">{item?.catatan_ban || item?.info || '-'}</div>
                        </div>
                      ))}
                      {!selectedDetailHistori.length && <small className="text-muted">Belum ada histori.</small>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
  }

function PanelTambalBan({ action, activeMenu, setActiveMenu, dataWO, setDataWO, opsiMT, opsiCabang, authIdentity = {}, mtProfilMap, mtDetailMap, globalOpsi, resendToken = 0 }) {
  const { showNotif } = useNotification();
  const actorKodeCabang = String(authIdentity?.kode_cabang || '').trim();
  const actorNama = String(authIdentity?.nama || '').trim();
  const isPusat = actorKodeCabang === 'C-1';
  const namaCabangUser = (
    (Array.isArray(opsiCabang) ? opsiCabang : []).find((x) => String(x?.kode_cabang || '').trim() === actorKodeCabang)?.nama_cabang
    || actorKodeCabang
    || ''
  );
  const [bisaSubmit, setBisaSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [invalidCaptionIndexes, setInvalidCaptionIndexes] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [summary, setSummary] = useState({
    odo: { value: '-', date: null },
    td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
    banDetails: {},
    banPositionMap: {}
  });
  const [showBanPopup, setShowBanPopup] = useState(false);
  const [openPilihBanTambalModal, setOpenPilihBanTambalModal] = useState(false);
  const [showOdoUpdateModal, setShowOdoUpdateModal] = useState(false);
  const [showTdUpdateModal, setShowTdUpdateModal] = useState(false);
  const [selectedPosisi, setSelectedPosisi] = useState('');
  const [todayCheckStatus, setTodayCheckStatus] = useState({ odo: false, td: false });
  const [selectedTambalBanRows, setSelectedTambalBanRows] = useState([]);
  const [selectedTambalBanIds, setSelectedTambalBanIds] = useState([]);
  const [banEventMap, setBanEventMap] = useState({});
  const [loadingPilihBanMeta, setLoadingPilihBanMeta] = useState(false);
  const [showMtDetailModal, setShowMtDetailModal] = useState(false);
  const [mtDetailData, setMtDetailData] = useState(null);
  const [showCariMtTambalModal, setShowCariMtTambalModal] = useState(false);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);
  const [showTambalDetailModal, setShowTambalDetailModal] = useState(false);
  const [activeTambalDetailRowId, setActiveTambalDetailRowId] = useState(0);
  const [opsiJenisTambal, setOpsiJenisTambal] = useState([]);
  const [opsiBahanTambal, setOpsiBahanTambal] = useState([]);

  const todayISO = formatYYYYMMDD(new Date());
  const alertLengkapi = 'Lengkapi cabang, No. Pol MT, serta waktu mulai/selesai untuk membuka panel detail tambal ban.';
  const warningCheck = 'Anda belum dapat melanjutkan proses tambal ban karena data ODO dan TD ban belum update per hari ini.';
  const labelDetailMt = `Lihat Detail MT (Tambal Ban) : ${dataWO?.nopol ?? ''}`;
  const labelUpload = 'Upload Dokumen Tambal Ban';
  const labelDetailPopup = 'Histori ban diambil dari ban_event.';
  const formatDateLocal = formatDateLocalLabel;
  const dayDiffLabel = dayDiffLabelFromKey;
  const buildTambalCatatanSummary = (row) => {
    const catatan = String(row?.catatan || '').trim();
    const jenis = String(row?.jenis_tambal || '').trim();
    const bahan = String(row?.bahan_tambal || '').trim();
    return catatan || jenis || bahan || '-';
  };
  const getTambalStatusOptions = (statusBeforeRaw) => {
    const statusBefore = String(statusBeforeRaw || "").trim().toUpperCase();
    if (statusBefore === "NT") return ["NT", "UT", "CASING"];
    if (statusBefore === "UT") return ["UT", "CASING"];
    const vt = statusBefore.match(/^VT-(\d+)$/);
    const uv = statusBefore.match(/^UV-(\d+)$/);
    const tier = vt?.[1] || uv?.[1] || "";
    if (vt?.[1]) return [`VT-${tier}`, `UV-${tier}`, "CASING"];
    if (uv?.[1]) return [`UV-${tier}`, "CASING"];
    return [statusBefore || "-"];
  };
  const getSelectedMT = () => opsiMT.find((x) => x.id_mt === dataWO?.mt) || null;
  const buildMtDetailData = () => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) return null;
    const row = selectedMtDetail || mtDetailMap?.[idMt] || {};
    const selected = getSelectedMT() || {};
    const profil = {
      roda: Number(row?.roda || mtProfilMap?.[idMt]?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || mtProfilMap?.[idMt]?.cadangan || selected?.cadangan || 0),
    };
    return {
      id_mt: row?.id_mt || selected?.id_mt || idMt,
      nopol: row?.nopol || selected?.nopol || '-',
      kode_cabang: row?.kode_cabang || selected?.kode_cabang || dataWO?.pengirim || actorKodeCabang || '',
      merk: row?.merk || '-',
      kapasitas: row?.kapasitas || '-',
      kategori: row?.kategori || '-',
      status: row?.status || '-',
      roda: Number(row?.roda || profil?.roda || selected?.roda || 0),
      cadangan: Number(row?.cadangan || profil?.cadangan || selected?.cadangan || 0),
      tahun_pembuatan: row?.tahun_pembuatan || '',
      kir: row?.kir || '',
      odo_awal: Number(row?.odo_awal || 0),
      catatan_mt: row?.catatan_mt || '',
      tanggal: row?.tanggal || '',
      user: row?.user || actorNama || '',
      lampiran: Array.isArray(row?.lampiran) ? row.lampiran : [],
      lampiran_mt_event: row?.lampiran_mt_event || ''
    };
  };
  const openMtDetailModal = () => {
    const detail = buildMtDetailData();
    if (!detail) return;
    setMtDetailData(detail);
    setShowMtDetailModal(true);
  };
  const activeTambalDetailRow = useMemo(
    () => (Array.isArray(selectedTambalBanRows) ? selectedTambalBanRows : [])
      .find((row) => Number(row?.id_ban || 0) === Number(activeTambalDetailRowId || 0)) || null,
    [selectedTambalBanRows, activeTambalDetailRowId]
  );
  const selectedMtProfil = selectedMtDetail
    ? {
        roda: Number(selectedMtDetail?.roda || 0),
        cadangan: Number(selectedMtDetail?.cadangan || 0),
      }
    : (mtProfilMap?.[dataWO?.mt] || null);
  const isDataKunciTerisi = Boolean(
    dataWO?.pengirim
    && dataWO?.mt
    && String(dataWO?.start || '').trim() !== ''
    && String(dataWO?.end || '').trim() !== ''
  );
  const selectedDetail = summary.banDetails?.[selectedPosisi] || null;
  const selectedDetailHistori = banEventMap?.[Number(selectedDetail?.idBan || 0)] || [];
  const resolveBanCard = (posisi) => {
    if (!posisi) return null;
    const base = summary?.banDetails?.[posisi] || null;
    if (!base) return null;
    const histori = banEventMap?.[base.idBan] || [];
    const latestEvent = histori[0] || null;
    return {
      ...base,
      latestStatus: latestEvent?.status || base?.statusProfil || '-',
      latestCatatan: latestEvent?.catatan_ban || '-',
      histori,
    };
  };
  const rowsTambalValid = useMemo(() => (
    (Array.isArray(selectedTambalBanRows) ? selectedTambalBanRows : []).every((row) => {
      const qtyTambal = Number(row?.qty_tambal);
      return Number.isFinite(qtyTambal)
        && qtyTambal >= 0
        && qtyTambal <= 4
        && String(row?.status_after || '').trim() !== ''
        && String(row?.jenis_tambal || '').trim() !== '';
    })
  ), [selectedTambalBanRows]);
  const isTambalRowDetailInvalid = (row) => {
    const qtyTambal = Number(row?.qty_tambal);
    return !String(row?.jenis_tambal || '').trim()
      || !Number.isFinite(qtyTambal)
      || qtyTambal < 0
      || qtyTambal > 4;
  };
  const checkHarianSiap = Boolean(todayCheckStatus.odo && todayCheckStatus.td);
  const dataFinalLengkap = isDataKunciTerisi
    && String(dataWO?.nama_pemeriksa_mt || '').trim() !== ''
    && checkHarianSiap
    && Array.isArray(selectedTambalBanRows)
    && selectedTambalBanRows.length > 0
    && rowsTambalValid;
  const invalidCabangTambal = !String(dataWO?.pengirim || '').trim();
  const invalidMtTambal = !String(dataWO?.mt || '').trim();
  const invalidTimeTambal = !String(dataWO?.start || '').trim() || !String(dataWO?.end || '').trim() || String(dataWO?.start || '') >= String(dataWO?.end || '');
  const invalidPilihBanTambal = isDataKunciTerisi && checkHarianSiap && selectedTambalBanRows.length === 0;
  const invalidPetugasTambal = isDataKunciTerisi && !String(dataWO?.nama_pemeriksa_mt || '').trim();
  const collectInvalidCaptionIndexes = () => (
    (Array.isArray(attachments) ? attachments : [])
      .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );

  useEffect(() => {
    const defaultPengirim = actorKodeCabang === 'C-1' ? '' : (actorKodeCabang || 'invalid');
    setDataWO(prev => ({
      ...prev,
      jenis: action.value,
      pengirim: defaultPengirim,
      penerima: '',
      mt: '',
      nopol: '',
      start: '',
      end: '',
      patch_kebutuhan: 0,
      catatan_mt: '',
      check_validasi_mt: false,
      nama_pemeriksa_mt: actorNama ?? ''
    }));
  }, []);

  useEffect(() => {
    if (activeMenu !== action.value) return;
    const loadTambalOpsiTambahan = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_TAMBAL_OPSI_LOAD,
          reason: 'refresh opsi tambahan tambal',
        });
        const { data } = await api.get(`${backendPort}/api/main/load_opsi_tambahan_tambal`, {
          requestGroup: REQ_GROUP_WO_TAMBAL_OPSI_LOAD,
          timeout: 30000,
        });
        setOpsiJenisTambal(Array.isArray(data?.opsiJenisTambal) ? data.opsiJenisTambal : []);
        setOpsiBahanTambal(Array.isArray(data?.opsiBahanTambal) ? data.opsiBahanTambal : []);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat opsi tambahan tambal:', err);
        setOpsiJenisTambal([]);
        setOpsiBahanTambal([]);
      }
    };
    loadTambalOpsiTambahan();
  }, [activeMenu, action.value]);

  useEffect(() => {
    setBisaSubmit(dataFinalLengkap);
  }, [dataFinalLengkap]);

  useEffect(() => {
    const idMt = String(dataWO?.mt || '').trim();
    if (!idMt) {
      setSelectedMtDetail(null);
      return;
    }
    let alive = true;
    const loadMtDetailById = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_MT_PROFIL_LOAD,
          reason: `refresh mt profil tambal ${idMt}`,
        });
        const { data: rows } = await api.get(`${backendPort}/api/main/mt_profil`, {
          params: { id_mt: idMt },
          requestGroup: REQ_GROUP_WO_MT_PROFIL_LOAD,
          timeout: 120000,
        });
        if (!alive) return;
        const row = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
        setSelectedMtDetail(row);
      } catch (err) {
        if (!alive) return;
        if (api.isCanceledError(err)) return;
        console.error('Gagal memuat detail MT tambal:', err);
        setSelectedMtDetail(null);
      }
    };
    loadMtDetailById();
    return () => {
      alive = false;
    };
  }, [dataWO?.mt]);

  const loadLastCheckSummary = async (idMt, force = false) => {
    if (!idMt) {
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
      setSelectedPosisi('');
      return;
    }

    setLoadingSummary(true);
    setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
    setTodayCheckStatus({ odo: false, td: false });
    try {
      const selectedMT = getSelectedMT();
      const result = await loadGlobalOdoTdCheckByMt(idMt, selectedMT, force);
      setSummary(result.summary);
      setTodayCheckStatus(result.todayCheckStatus);
      setSelectedPosisi(Object.keys(result.summary?.banDetails || {})[0] || '');
    } catch (error) {
      if (api.isCanceledError(error)) return;
      console.error(error);
      setSummary({ ...EMPTY_ODO_TD_SUMMARY, banDetails: {}, banPositionMap: {} });
      setTodayCheckStatus({ odo: false, td: false });
      setSelectedPosisi('');
    } finally {
      setLoadingSummary(false);
    }
  };

  useEffect(() => {
    if (!isDataKunciTerisi) return;
    loadLastCheckSummary(dataWO?.mt, Boolean(resendToken));
  }, [isDataKunciTerisi, dataWO?.mt, resendToken]);

  useEffect(() => {
    if (isDataKunciTerisi) return;
    setSummary({
      odo: { value: '-', date: null },
      td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: null },
      banDetails: {},
      banPositionMap: {}
    });
    setTodayCheckStatus({ odo: false, td: false });
    setSelectedPosisi('');
    setShowBanPopup(false);
    setOpenPilihBanTambalModal(false);
    setShowOdoUpdateModal(false);
    setShowTdUpdateModal(false);
    setShowTambalDetailModal(false);
    setActiveTambalDetailRowId(0);
    setSelectedTambalBanRows([]);
    setSelectedTambalBanIds([]);
  }, [isDataKunciTerisi]);

  useEffect(() => {
    const loadHistoriBan = async () => {
      if (!openPilihBanTambalModal && !showBanPopup) return;
      const ids = [...new Set(
        Object.values(summary?.banDetails || {})
          .map((x) => Number(x?.idBan || 0))
          .filter((x) => Number.isFinite(x) && x > 0)
      )];
      if (!ids.length) {
        setBanEventMap({});
        return;
      }
      setLoadingPilihBanMeta(true);
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_WO_TAMBAL_HISTORY_LOAD,
          reason: 'refresh histori ban tambal',
        });
        const { data } = await api.post(`${backendPort}/api/main/load_ban_event_history_by_ban`, { kodeBan: ids }, {
          requestGroup: REQ_GROUP_WO_TAMBAL_HISTORY_LOAD,
          timeout: 30000,
        });
        const rows = Array.isArray(data) ? data : [];
        const mapped = {};
        rows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan) return;
          if (!mapped[idBan]) mapped[idBan] = [];
          mapped[idBan].push(row);
        });
        setBanEventMap(mapped);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error(err);
        setBanEventMap({});
      } finally {
        setLoadingPilihBanMeta(false);
      }
    };
    loadHistoriBan();
  }, [openPilihBanTambalModal, showBanPopup, summary?.banDetails, resendToken]);

  const handleOdoTdSaved = () => {
    if (!dataWO?.mt) return;
    loadLastCheckSummary(dataWO.mt, true);
  };
  const openTambalDetailModal = (row) => {
    const id = Number(row?.id_ban || 0);
    if (!id) return;
    setActiveTambalDetailRowId(id);
    setShowTambalDetailModal(true);
  };

  const handleSubmit = async () => {
    if (!bisaSubmit) {
      showNotif("error", "Lengkapi data tambal ban, pilihan ban, status, detail tambal, serta verifikasi pemeriksa terlebih dahulu.");
      return;
    }
    if (!String(dataWO?.nomor || '').trim()) {
      showNotif("error", "Nomor WO belum tersedia. Klik Refresh lalu coba lagi.");
      return;
    }
    if (!String(dataWO?.start || '').trim() || !String(dataWO?.end || '').trim()) {
      showNotif("error", "Waktu mulai dan waktu selesai wajib diisi.");
      return;
    }
    if (String(dataWO?.start || '') >= String(dataWO?.end || '')) {
      showNotif("error", "Waktu selesai harus lebih besar dari waktu mulai.");
      return;
    }
    const rowsPayload = (Array.isArray(selectedTambalBanRows) ? selectedTambalBanRows : [])
      .map((row) => ({
        id_ban: Number(row?.id_ban || 0),
        posisi: String(row?.posisi || '').trim(),
        qty_tambal: Number(row?.qty_tambal || 0),
        catatan: String(row?.catatan || ''),
        jenis_tambal: String(row?.jenis_tambal || '').trim(),
        bahan_tambal: String(row?.bahan_tambal || '').trim(),
        status_lama: String(row?.status_before || '').trim(),
        status_baru: String(row?.status_after || '').trim(),
      }))
      .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0 && row.posisi);
    if (!rowsPayload.length) {
      showNotif("error", "Pilih ban yang akan ditambal terlebih dahulu.");
      return;
    }
    const invalidQtyRow = rowsPayload.find((row) => !Number.isFinite(row.qty_tambal) || row.qty_tambal < 0 || row.qty_tambal > 4);
    if (invalidQtyRow) {
      showNotif("error", `Quantity tambal id_ban ${invalidQtyRow.id_ban} harus 0 sampai 4.`);
      return;
    }
    const invalidStatusRow = rowsPayload.find((row) => !String(row?.status_baru || '').trim());
    if (invalidStatusRow) {
      showNotif("error", `Status baru id_ban ${invalidStatusRow.id_ban} belum dipilih.`);
      return;
    }
    const invalidJenisRow = rowsPayload.find((row) => !String(row?.jenis_tambal || '').trim());
    if (invalidJenisRow) {
      showNotif("error", `Jenis tambal id_ban ${invalidJenisRow.id_ban} wajib dipilih.`);
      return;
    }
    const invalidIndexes = collectInvalidCaptionIndexes();
    if (invalidIndexes.length > 0) {
      setInvalidCaptionIndexes(invalidIndexes);
      showNotif('error', 'Caption dokumen wajib diisi untuk semua lampiran.');
      return;
    }
    setInvalidCaptionIndexes([]);

    setIsSubmitting(true);
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_WO_TAMBAL_SUBMIT,
        reason: 'submit tambal terbaru',
      });
      const formData = new FormData();
      formData.append('nomorWO', String(dataWO?.nomor || '').trim());
      formData.append('tanggal', dataWO?.tanggal || '');
      formData.append('kode_cabang', dataWO?.pengirim || actorKodeCabang || '');
      formData.append('id_mt', dataWO?.mt || '');
      formData.append('rows', JSON.stringify(rowsPayload));
      formData.append('start', dataWO?.start || '');
      formData.append('end', dataWO?.end || '');
      formData.append('user', dataWO?.user || actorNama || '');
      attachments.forEach((item) => {
        if (item?.file) formData.append('files', item.file);
        formData.append('captions', item?.caption || '');
      });
      const existingLampiran = attachments
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || '',
          file: item?.db_file || item?.file || '',
          path: item?.path || '',
          type: item?.type || '',
          size: Number(item?.size || 0),
          caption: item?.caption || '',
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append('existing_lampiran', JSON.stringify(existingLampiran));

      await api.post(`${backendPort}/api/main/submit_tambal_mt_bulk`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        requestGroup: REQ_GROUP_WO_TAMBAL_SUBMIT,
        timeout: 120000,
      });
      setSelectedTambalBanRows([]);
      setSelectedTambalBanIds([]);
      setInvalidCaptionIndexes([]);
      await loadLastCheckSummary(dataWO?.mt, true);
      setActiveMenu('');
      showNotif("success", "Tambal ban berhasil disimpan.");
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit tambal ban.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenPilihBanTambalMulti = async () => {
    if (!isDataKunciTerisi) {
      showNotif("error", "Lengkapi data utama terlebih dahulu.");
      return;
    }
    if (!summary?.td?.total) {
      showNotif("error", "Data ban MT belum tersedia.");
      return;
    }
    setOpenPilihBanTambalModal(true);
  };
  const handleSelesaiPilihBanTambal = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    setSelectedTambalBanIds(normalizedIds);
    const rowMap = new Map((Array.isArray(rows) ? rows : []).map((row) => [Number(row?.id_ban || 0), row]));
    const mappedRows = normalizedIds.map((idBan) => {
      const base = rowMap.get(Number(idBan)) || {};
      const statusBefore = String(base?.status || "").trim();
      const opsiStatus = getTambalStatusOptions(statusBefore);
      return {
        id_ban: Number(idBan),
        seri_ban: String(base?.seri_ban || "").trim(),
        posisi: String(base?.posisi || "").trim(),
        status_before: statusBefore,
        status_after: String(opsiStatus?.[0] || statusBefore || "").trim(),
        qty_tambal: 0,
        jenis_tambal: '',
        bahan_tambal: '',
        catatan: "",
      };
    });
    setSelectedTambalBanRows(mappedRows);
    showNotif("success", `${normalizedIds.length} ban dipilih.`);
  };
  const updateTambalBanDetail = (idBan, nextDetail = {}) => {
    const id = Number(idBan || 0);
    if (!id) return;
    setSelectedTambalBanRows((prev) => prev.map((row) => (
      Number(row?.id_ban || 0) === id
        ? {
            ...row,
            jenis_tambal: String(nextDetail?.jenis_tambal || '').trim(),
            bahan_tambal: String(nextDetail?.bahan_tambal || '').trim(),
            qty_tambal: Number(nextDetail?.qty_tambal || 0),
            catatan: String(nextDetail?.catatan || ''),
          }
        : row
    )));
  };
  const updateTambalBanStatus = (idBan, statusBaru) => {
    const id = Number(idBan || 0);
    if (!id) return;
    const val = String(statusBaru || "").trim();
    setSelectedTambalBanRows((prev) => prev.map((row) => (
      Number(row?.id_ban || 0) === id ? { ...row, status_after: val } : row
    )));
  };

  if (activeMenu !== action.value) return null;

  return (
    <div className={`page16-panel-form ${panelAccentClassByAction(action?.value)}`}>
      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
        <div>
          <p className="page16-panel-label mb-1">Detail Aktivitas</p>
          <h4 className="page16-panel-title mb-1">{action.title}</h4>
          <p className="text-muted small mb-0">{action.description}</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveMenu('')}>
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>
      <div className="row g-3 mb-3">
        <div className="col-12 col-md-4">
          <label className="form-label">Cabang</label>
          <select type="text" className={`form-select ${invalidCabangTambal ? 'field-required-invalid' : ''}`} value={dataWO?.pengirim ?? ''} onChange={(e) => setDataWO(prev => ({ ...prev, pengirim: e.target.value, mt: '', nopol: '' }))}>
            {!isPusat && <option key={""} value={actorKodeCabang}>{namaCabangUser || actorKodeCabang}</option>}
            {isPusat && <option key={""} value={""}>-Pilih Cabang-</option>}
            {isPusat && opsiCabang.map((x) => <option key={x.kode_cabang} value={x.kode_cabang}>{x.nama_cabang}</option>)}
          </select>
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">No. Transaksi</label>
          <input type="text" className="form-control" readOnly value={toNomorPreviewDisplay(dataWO?.nomor || '')} />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Tanggal Input</label>
          <input
            type="date"
            className={`form-control ${invalidMtTambal ? 'field-required-invalid' : ''}`}
            value={dataWO?.tanggal || ''}
            readOnly
          />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">No. Pol. MT</label>
          <input
            type="text"
            className={`form-control ${invalidMtTambal ? 'field-required-invalid' : ''}`}
            readOnly
            style={{ cursor: 'pointer' }}
            placeholder="Pilih NoPol MT"
            value={dataWO?.nopol || ''}
            onClick={() => {
              if (!dataWO?.pengirim) return;
              setShowCariMtTambalModal(true);
            }}
          />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Waktu Mulai</label>
          <input
            type="time"
            className={`form-control ${invalidTimeTambal ? 'field-required-invalid' : ''}`}
            value={dataWO?.start || ''}
            onChange={(e) => setDataWO((prev) => ({ ...prev, start: e.target.value }))}
          />
        </div>
        <div className="col-12 col-md-4">
          <label className="form-label">Waktu Selesai</label>
          <input
            type="time"
            className={`form-control ${invalidTimeTambal ? 'field-required-invalid' : ''}`}
            value={dataWO?.end || ''}
            onChange={(e) => setDataWO((prev) => ({ ...prev, end: e.target.value }))}
          />
        </div>
      </div>

      <div className="row g-3">
        {!isDataKunciTerisi && (
          <div className="col-12">
            <div className="alert page16-muted-alert mb-0">
              {alertLengkapi}
            </div>
          </div>
        )}
      </div>

      {isDataKunciTerisi && (
        <div className="row g-3 mt-1">
          <div className="col-12">
            <div className="card page16-info-card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="page16-info-title">LAST Check</span>
                  <span className="badge text-bg-light">{dataWO?.nopol || 'Belum pilih MT'}</span>
                </div>
                <div className="row g-2">
                  <div className="col-12 col-md-6">
                    <div className="page16-info-item">
                      <small>ODO / KM TEMPUH MT</small>
                      <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowOdoUpdateModal(true)}>
                        {loadingSummary ? 'Memuat...' : summary.odo.value}
                      </button>
                      <span className={todayCheckStatus.odo ? 'text-success' : 'text-danger'}>
                        Check: {formatDateLocal(todayCheckStatus.odo ? todayISO : summary.odo.date)} ({dayDiffLabel(todayCheckStatus.odo ? todayISO : summary.odo.date)})
                      </span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="page16-info-item">
                      <small>TD BAN</small>
                      <button type="button" className="btn page16-gradient-btn text-white fw-bold" onClick={() => setShowTdUpdateModal(true)}>
                        {loadingSummary ? 'Memuat...' : `${summary.td.terpasang} + ${summary.td.cadangan} ban`}
                      </button>
                      <span className={todayCheckStatus.td ? 'text-success' : 'text-danger'}>
                        Check: {formatDateLocal(todayCheckStatus.td ? todayISO : summary.td.oldestDate)} ({dayDiffLabel(todayCheckStatus.td ? todayISO : summary.td.oldestDate)})
                      </span>
                    </div>
                  </div>
                </div>
                {(!todayCheckStatus.odo || !todayCheckStatus.td) && (
                  <div className="mt-2">
                    <small className="text-danger fst-italic fw-light">
                      {warningCheck}
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card page16-soft-card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <span>{labelDetailMt}</span>
                  <button
                    className='btn btn-outline-primary'
                    disabled={!summary.td.total}
                    onClick={openMtDetailModal}
                  >
                    Lihat
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card page16-soft-card">
              <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                <span>Pilih Ban Tambal</span>
                <button
                  className={`btn btn-outline-primary ${invalidPilihBanTambal ? 'field-required-invalid-btn' : ''}`}
                  disabled={!summary.td.total}
                  onClick={handleOpenPilihBanTambalMulti}
                >
                  Buka
                </button>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card page16-soft-card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="fw-semibold">Daftar Ban Repair/Tambal</div>
                  {loadingPilihBanMeta && <small className="text-muted">Memuat opsi ban...</small>}
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-hover align-middle">
                    <thead>
                      <tr>
                        <th>id_ban</th>
                        <th>Seri Ban</th>
                        <th>Posisi</th>
                        <th>Status</th>
                        <th style={{ minWidth: "200px" }}>Catatan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loadingPilihBanMeta && selectedTambalBanRows.length === 0 && (
                        <tr>
                          <td colSpan={5} className="text-center text-muted">Belum ada ban dipilih.</td>
                        </tr>
                      )}
                      {selectedTambalBanRows.map((row) => (
	                        <tr key={`tambal-ban-row-${row.id_ban}`}>
	                          <td>{Number(row?.id_ban || 0)}</td>
	                          <td>{String(row?.seri_ban || "-")}</td>
	                          <td>{String(row?.posisi || "-")}</td>
	                          <td>
	                            <select
	                              className={`form-select form-select-sm ${!String(row?.status_after || '').trim() ? 'field-required-invalid' : ''}`}
	                              value={String(row?.status_after || "")}
	                              onChange={(e) => updateTambalBanStatus(row.id_ban, e.target.value)}
	                            >
	                              {getTambalStatusOptions(row?.status_before).map((opt) => (
	                                <option key={`tambal-status-${row.id_ban}-${opt}`} value={opt}>
	                                  {opt === "CASING" ? "Casing" : opt}
	                                </option>
	                              ))}
	                            </select>
	                          </td>
	                          <td>
	                            <button
	                              type="button"
	                              className={`form-control form-control-sm text-start ${isTambalRowDetailInvalid(row) ? 'field-required-invalid' : ''}`}
	                              onClick={() => openTambalDetailModal(row)}
	                            >
	                              {buildTambalCatatanSummary(row)}
	                            </button>
	                          </td>
	                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-2 small fw-semibold">
                  {`Repair/Tambal Ban MT sebanyak ${selectedTambalBanRows.length} ban.`}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card page16-soft-card h-100">
              <div className='card-body'>
                <div className='d-flex justify-content-center'>
                  <span>{labelUpload}</span>
                </div>
                <PageKonten9_Pict
                  attachments={attachments}
                  setAttachments={setAttachments}
                  bisaInput={true}
                  invalidCaptionIndexes={invalidCaptionIndexes}
                  onCaptionChange={() => {
                    if (!invalidCaptionIndexes.length) return;
                    setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card page16-verify-card page16-soft-card">
              <div className="card-body">
                <div className="row g-2 align-items-center">
                  <div className="col-12 col-md-8">
                    <span className="fw-semibold">Petugas Input</span>
                  </div>
                  <div className="col-12 col-md-4">
                    <input
                      type="text"
                      className={`form-control ${invalidPetugasTambal ? 'field-required-invalid' : ''}`}
                      placeholder="Nama user pemeriksa"
                      value={dataWO?.nama_pemeriksa_mt ?? ''}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDataKunciTerisi && (
        <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveMenu('')}>
            Batal
          </button>
	          <button type="button" className={`btn btn-primary ${!bisaSubmit ? 'field-required-invalid-btn' : ''}`} onClick={handleSubmit} disabled={!bisaSubmit || isSubmitting}>
            {isSubmitting ? 'Memproses...' : action.submitLabel}
          </button>
        </div>
      )}

      <ModalCariMT
        open={showCariMtTambalModal}
        onClose={() => setShowCariMtTambalModal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || '').trim();
          const nopol = String(mt?.nopol || '').trim();
          setDataWO((prev) => ({ ...prev, mt: idMt, nopol }));
        }}
        title="Pilih No. Pol MT"
        globalOpsi={globalOpsi}
        kodeCabang={dataWO?.pengirim || actorKodeCabang || ""}
        treatPusatAsAll={false}
      />

      {showOdoUpdateModal && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: 'min(1100px, 96vw)' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="odo"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowOdoUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showTdUpdateModal && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '97vw' }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={{ opsiCabang, opsiMT }}
              mode="modal"
              forcedAction="td"
              presetMtId={dataWO?.mt || ''}
              presetKodeCabang={dataWO?.pengirim || actorKodeCabang || ''}
              presetTanggal={todayISO}
              onClose={() => setShowTdUpdateModal(false)}
              onAfterSave={handleOdoTdSaved}
            />
          </div>
        </div>
      )}

      {showMtDetailModal && mtDetailData && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: '90vw', maxHeight: '92vh', overflowY: 'auto' }}>
            <PageKonten9_Show
              globalOpsi={globalOpsi}
              editData={mtDetailData}
              setShowDetail={setShowMtDetailModal}
              setShowMaster={() => {}}
            />
          </div>
        </div>
      )}

      {showBanPopup && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card">
            <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
              <div>
                <h5 className="mb-1">Detail Ban MT - {dataWO?.nopol || '-'}</h5>
                <small className="text-muted">{labelDetailPopup}</small>
              </div>
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowBanPopup(false)}>
                Tutup
              </button>
            </div>

            <div className="row g-3 justify-content-center">
              <div className="col-12 col-lg-5">
                <div className="page16-popup-formasi">
                  <FormasiBan
                    formasi={Number(selectedMtProfil?.roda || getSelectedMT()?.roda || 16)}
                    cadangan={Number(selectedMtProfil?.cadangan || getSelectedMT()?.cadangan || 3)}
                    onClick={(pos) => setSelectedPosisi(pos)}
                    daftarKodeBan={summary.banPositionMap}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="page16-popup-detail">
                  <h6 className="mb-3">{selectedDetail?.posisi || '-'} | Detail Ban</h6>
                  <div className="row g-2 small">
                    <div className="col-6"><strong>Posisi:</strong> {selectedDetail?.posisi || '-'}</div>
                    <div className="col-6"><strong>No Seri:</strong> {selectedDetail?.seri || '-'}</div>
                    <div className="col-6"><strong>TD:</strong> {selectedDetail?.td || '-'}</div>
                    <div className="col-6"><strong>KM Tempuh:</strong> {selectedDetail?.kmTempuh || 0}</div>
                    <div className="col-6"><strong>Wear Rate:</strong> {selectedDetail?.wearRate || '-'}</div>
                    <div className="col-6"><strong>Tgl Initial:</strong> {formatDateLocal(selectedDetail?.tanggalInitial)}</div>
                    <div className="col-6"><strong>Last cek ODO:</strong> {formatDateLocal(selectedDetail?.lastOdoDate)}</div>
                    <div className="col-6"><strong>Last cek TD:</strong> {formatDateLocal(selectedDetail?.lastTdDate)}</div>
                  </div>

                  <div className="mt-3">
                    <strong className="small d-block mb-1">Histori Ban</strong>
                    <div className="page16-rotasi-histori">
                      {selectedDetailHistori.slice(0, 12).map((item, idx) => (
                        <div key={`tambal-detail-${idx}`} className="page16-rotasi-histori-item">
                          <small className="text-muted">{formatDateLocal(item?.tanggal)} | {item?.event || '-'}</small>
                          <div className="small">{item?.catatan_ban || item?.info || '-'}</div>
                        </div>
                      ))}
                      {!selectedDetailHistori.length && <small className="text-muted">Belum ada histori.</small>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalPickTambalBanMulti
        open={openPilihBanTambalModal}
        onClose={() => setOpenPilihBanTambalModal(false)}
        onSubmit={handleSelesaiPilihBanTambal}
        formasi={Number(selectedMtProfil?.roda || getSelectedMT()?.roda || 16)}
        cadangan={Number(selectedMtProfil?.cadangan || getSelectedMT()?.cadangan || 3)}
        daftarKodeBan={summary?.banPositionMap || {}}
        banDetails={summary?.banDetails || {}}
        banEventMap={banEventMap || {}}
        title={`Pilih Ban Tambal - ${dataWO?.nopol || '-'}`}
        subtitle="Klik ban di formasi untuk menambah/mengurangi daftar ban tambal."
        initialSelectedIds={selectedTambalBanIds}
        formatDateLocal={formatDateLocal}
      />
      <ModalTambalDetail
        open={showTambalDetailModal}
        row={activeTambalDetailRow}
        opsiJenisTambal={opsiJenisTambal}
        opsiBahanTambal={opsiBahanTambal}
        onClose={() => {
          setShowTambalDetailModal(false);
          setActiveTambalDetailRowId(0);
        }}
        onSave={(detail) => {
          updateTambalBanDetail(activeTambalDetailRowId, detail);
          setShowTambalDetailModal(false);
          setActiveTambalDetailRowId(0);
        }}
      />
    </div>
  );
}
